<template>
  <div class="learning-container">
    <!-- 自定义小框提示 -->
    <transition name="tip-fade">
      <div v-if="showCustomTip" class="custom-tip-overlay" @click.self="handleConfirmTip">
        <div class="custom-tip-box">
          <div class="custom-tip-content">
            <i class="el-icon-warning"></i>
            <span>{{ customTipText }}</span>
          </div>
          <div class="custom-tip-footer">
            <button class="custom-tip-confirm-btn" @click="handleConfirmTip">确认</button>
          </div>
        </div>
      </div>
    </transition>
    <!-- 顶部导航 -->
    <div class="learning-header">
      <div class="header-left">
        <el-button 
          type="text" 
          icon="el-icon-back" 
          @click="goBack"
          class="back-btn"
        >
          返回
        </el-button>
        <h2>视频学习平台</h2>
      </div>
      <div class="header-right">
        <!-- <div class="progress-info">
          <span>学习进度: {{ progressPercentage }}%</span>
          <el-progress 
            :percentage="progressPercentage" 
            :stroke-width="8"
            color="#2a91ff"
          ></el-progress>
        </div> -->
      </div>
    </div>

    <div class="learning-content">
      <!-- 左侧章节列表 -->
      <div class="chapter-sidebar">
        <div class="sidebar-header">
          <!-- <h3>{{ isFromNotice ? courseName : '课程章节' }}</h3> -->
        </div>


        
        <!-- 课程类型数据显示（从Notice.vue跳转过来） -->
        <div v-if="isFromNotice" class="course-content">
          <!-- 加载状态 -->
          <div v-if="loadingVideos" class="loading-state">
            <i class="el-icon-loading"></i>
            <p>正在加载视频列表...</p>
          </div>
          
          <!-- 视频列表 -->
          <div v-else-if="courseVideos && courseVideos.length > 0" class="video-section">
            <div class="section-title">
              <i class="el-icon-video-play"></i>
              <span>课程视频</span>
            </div>
            <div class="video-list">
              <div
                v-for="(video, index) in courseVideos"
                :key="video.id"
                class="video-item"
                :class="{
                  active: currentVideoIndex === index && !showTest,
                  locked: !isVideoUnlockedById(video.id)
                }"
                @click="selectVideo(index)"
              >
                <div class="video-icon">
                  <i v-if="!isVideoUnlockedById(video.id)" class="el-icon-lock"></i>
                  <i v-else-if="currentVideoIndex === index && !showTest" class="el-icon-video-camera"></i>
                  <i v-else class="el-icon-video-play"></i>
                </div>
                <div class="video-info">
                  <div class="video-title">{{ video.title }}</div>
                  <div class="video-meta">{{ video.duration }}</div>
                </div>
                <div class="video-status">
                  <el-tag v-if="!isVideoUnlockedById(video.id)" type="info" size="mini">锁定</el-tag>
                  <el-tag v-else type="success" size="mini">可观看</el-tag>
                </div>
              </div>
            </div>
          </div>
          
          <!-- 空状态 -->
          <div v-else class="empty-state">
            <i class="el-icon-video-camera"></i>
            <p>暂无视频数据</p>
          </div>

          <!-- 测试题 -->
          <div v-if="currentCourseTest" class="test-section">
            <div class="section-title">
              <i class="el-icon-edit"></i>
              <span>课程测试</span>
            </div>
            <div class="test-list">
              <div
                class="test-item"
                :class="{ active: showTest }"
                @click="selectTest"
              >
                <div class="test-icon">
                  <i class="el-icon-edit"></i>
                </div>
                <div class="test-info">
                  <div class="test-title">{{ currentCourseTest.title }}</div>
                  <div class="test-meta">{{ currentCourseTest.questions.length }}题</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="chapter-list">
          <div
            v-for="chapter in courseData.chapters"
            :key="chapter.id"
            class="chapter-item"
            :class="{ active: currentChapter.id === chapter.id }"
            @click="selectChapter(chapter.id)"
          >
            <div class="chapter-header">
              <i class="el-icon-folder"></i>
              <span class="chapter-title">{{ chapter.title }}</span>
              <span class="chapter-progress">
                {{ getChapterProgress(chapter) }}/{{ chapter.lessons.length }}
              </span>
            </div>

            <div class="lesson-list" v-if="currentChapter.id === chapter.id">
              <div
                v-for="lesson in chapter.lessons"
                :key="lesson.id"
                class="lesson-item"
                :class="{
                  active: currentLesson && currentLesson.id === lesson.id,
                  completed: isLessonCompleted(lesson.id)
                }"
                @click.stop="selectLesson(lesson.id)"
              >
                <div class="lesson-icon">
                  <i :class="lesson.type === 'video' ? 'el-icon-video-play' : 'el-icon-edit'"></i>
                </div>
                <div class="lesson-info">
                  <div class="lesson-title">{{ lesson.title }}</div>
                  <div class="lesson-meta">
                    <span v-if="lesson.type === 'video'">{{ lesson.duration }}</span>
                    <span v-else>{{ lesson.questions.length }}题</span>
                  </div>
                </div>
                <div class="lesson-status">
                  <i v-if="isLessonCompleted(lesson.id)" class="el-icon-check"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧学习区域 -->
      <div class="learning-main">
        <div class="lesson-header">
          <h2>{{ currentContent ? currentContent.title : '请选择内容' }}</h2>
          <div class="lesson-nav" v-if="isFromNotice">
            <el-button
              :disabled="!canGoPrevious"
              @click="goToPrevious"
              icon="el-icon-arrow-left"
            >
              上一个
            </el-button>
            <el-button
              :disabled="!canGoNext"
              @click="goToNext"
              type="primary"
            >
              下一个
              <i class="el-icon-arrow-right el-icon--right"></i>
            </el-button>
          </div>
          <div class="lesson-nav" v-else>
            <el-button
              :disabled="!canGoPrevious"
              @click="previousLesson"
              icon="el-icon-arrow-left"
            >
              上一课
            </el-button>
            <el-button
              :disabled="!canGoNext"
              @click="nextLesson"
              type="primary"
            >
              下一课
              <i class="el-icon-arrow-right el-icon--right"></i>
            </el-button>
          </div>
        </div>

        <div class="lesson-content">
          <!-- 课程类型的视频显示 -->
          <div v-if="isFromNotice && !showTest && currentContent" class="video-lesson">
            <div class="video-container">
              <!-- 如果有真实的视频URL，显示视频播放器 -->
              <video
                v-if="currentContent.videoUrl && isValidVideoUrl(currentContent.videoUrl)"
                ref="videoPlayer"
                class="video-player"
                controls
                controlsList="nodownload noremoteplayback nopictureinpicture"
                preload="metadata"
                @ended="onVideoEnded"
                @loadedmetadata="onVideoLoaded"
              >
                <source :src="getVideoUrl(currentContent.videoUrl)" type="video/mp4">
                <p>您的浏览器不支持视频播放。</p>
              </video>

              <!-- 如果还没有选择视频，显示提示 -->
              <div v-else-if="!currentContent.videoUrl" class="video-placeholder">
                <i class="el-icon-video-camera"></i>
                <p>请选择视频进行播放</p>
              </div>

              <!-- 如果是无效URL，显示占位符 -->
              <div v-else class="video-placeholder">
                <i class="el-icon-video-camera"></i>
                <p>视频播放区域</p>
                <p class="video-url">{{ currentContent.videoUrl }}</p>
                <p class="video-note">视频URL格式不支持</p>
              </div>
            </div>
            <div class="video-info">
            </div>
          </div>

          <!-- 课程类型的测试题目 -->
          <div v-else-if="isFromNotice && showTest && currentContent" class="quiz-lesson">
            <div class="quiz-container">
              <div
                v-for="(question, index) in currentContent.questions"
                :key="question.id"
                class="question-item"
              >
                <div class="question-header">
                  <span class="question-number">第{{ index + 1 }}题</span>
                  <span class="question-type">单选题</span>
                </div>
                <div class="question-content">
                  <h4>{{ question.question }}</h4>
                  <div class="options">
                    <el-radio-group v-model="userAnswers[question.id]">
                      <el-radio
                        v-for="(option, optionIndex) in question.options"
                        :key="optionIndex"
                        :label="optionIndex + 1"
                        class="option-item"
                      >
                        {{ option }}
                      </el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </div>
            </div>

            <div class="quiz-actions">
              <el-button @click="resetQuiz">重置答案</el-button>
              <el-button
                type="primary"
                @click="submitQuiz"
                :disabled="!isQuizComplete"
              >
                提交答案
              </el-button>
            </div>
          </div>

          <!-- 原有的视频课程显示 -->
          <div v-else-if="!isFromNotice && currentLesson && currentLesson.type === 'video'" class="video-lesson">
            <div class="video-container">
              <!-- 如果有真实的视频URL，显示视频播放器 -->
              <video
                v-if="isValidVideoUrl(currentLesson.videoUrl)"
                ref="videoPlayerOriginal"
                class="video-player"
                controls
                controlsList="nodownload noremoteplayback nopictureinpicture"
                preload="metadata"
                @ended="onVideoEndedOriginal"
              >
                <source :src="currentLesson.videoUrl" type="video/mp4">
                <p>您的浏览器不支持视频播放。</p>
              </video>

              <!-- 如果是示例URL，显示占位符 -->
              <div v-else class="video-placeholder">
                <i class="el-icon-video-camera"></i>
                <p>视频播放区域</p>
                <p class="video-url">{{ currentLesson.videoUrl }}</p>
                <p class="video-note">这是一个示例URL，实际使用时请替换为真实的视频地址</p>
              </div>
            </div>
            <div class="video-info">
            </div>
          </div>

          <!-- 原有的测试题目显示 -->
          <div v-else-if="!isFromNotice && currentLesson && currentLesson.type === 'quiz'" class="quiz-lesson">
            <div class="quiz-container">
              <div 
                v-for="(question, index) in currentLesson.questions" 
                :key="question.id"
                class="question-item"
              >
                <div class="question-header">
                  <span class="question-number">第{{ index + 1 }}题</span>
                  <span class="question-type">单选题</span>
                </div>
                <div class="question-content">
                  <h4>{{ question.question }}</h4>
                  <div class="options">
                    <el-radio-group v-model="userAnswers[question.id]">
                      <el-radio 
                        v-for="(option, optionIndex) in question.options" 
                        :key="optionIndex"
                        :label="optionIndex + 1"
                        class="option-item"
                      >
                        {{ String.fromCharCode(65 + optionIndex) }}. {{ option }}
                      </el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="quiz-actions">
              <el-button 
                type="primary" 
                @click="submitQuiz"
                :disabled="!isQuizComplete"
              >
                提交答案
              </el-button>
              <el-button @click="resetQuiz">
                重置
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { get } from '@/common/request'

export default {
  name: 'Learning',
  data() {
    return {
      userAnswers: {},
      currentVideoIndex: 0,
      showTest: false,
      loadingVideos: false,
      courseCategories: [],
      // 直接存储视频列表数据
      courseVideos: [],
      // 当前课程测试是否解锁
      examUnlocked: false,
      courseName: '',
      // 组件销毁标志
      isDestroyed: false,
      // 防录屏相关
      screenBlockInterval: null,
      isScreenRecording: false,
      // 自定义小框提示
      showCustomTip: false,
      customTipText: '',
      customTipTimer: null
    }
  },
  computed: {
    ...mapState(['courseData', 'currentCourseType', 'currentVideoId']),
    ...mapGetters(['currentChapter', 'currentLesson', 'progressPercentage', 'currentCourseTest', 'currentVideo', 'isVideoUnlocked', 'getCourseProgress']),
    
    // 判断是否显示课程类型数据（从Notice.vue跳转过来）
    isFromNotice() {
      const result = this.currentCourseType && this.courseVideos.length > 0
      console.log('isFromNotice check:', {
        currentCourseType: this.currentCourseType,
        courseVideosLength: this.courseVideos.length,
        result: result
      })
      return result
    },

    // 当前显示的视频或测试
    currentContent() {
      if (!this.isFromNotice) {
        return this.currentLesson || null
      }

      if (this.showTest) {
        return this.currentCourseTest || null
      }

      return this.courseVideos[this.currentVideoIndex] || null
    },



    canGoPrevious() {
      if (this.isFromNotice) {
        return this.currentVideoIndex > 0 || this.showTest
      }

      // 添加空值检查
      if (!this.currentChapter || !this.currentLesson || !this.courseData.chapters) {
        return false
      }

      const currentChapterIndex = this.courseData.chapters.findIndex(
        ch => ch.id === this.currentChapter.id
      )
      const currentLessonIndex = this.currentChapter.lessons.findIndex(
        lesson => lesson.id === this.currentLesson.id
      )
      return currentChapterIndex > 0 || currentLessonIndex > 0
    },

    canGoNext() {
      if (this.isFromNotice) {
        return this.courseVideos && this.currentVideoIndex < this.courseVideos.length - 1 || !this.showTest
      }

      // 添加空值检查
      if (!this.currentChapter || !this.currentLesson || !this.courseData.chapters) {
        return false
      }

      const currentChapterIndex = this.courseData.chapters.findIndex(
        ch => ch.id === this.currentChapter.id
      )
      const currentLessonIndex = this.currentChapter.lessons.findIndex(
        lesson => lesson.id === this.currentLesson.id
      )
      return currentChapterIndex < this.courseData.chapters.length - 1 ||
             currentLessonIndex < this.currentChapter.lessons.length - 1
    },

    isQuizComplete() {
      if (this.isFromNotice && this.showTest && this.currentCourseTest) {
        return this.currentCourseTest.questions.every(
          question => this.userAnswers[question.id] !== undefined
        )
      }

      if (!this.isFromNotice && this.currentLesson && this.currentLesson.type === 'quiz') {
        return this.currentLesson.questions.every(
          question => this.userAnswers[question.id] !== undefined
        )
      }

      return false
    }
  },
  methods: {
    ...mapActions(['nextLesson', 'previousLesson']),

    goBack() {
      this.$router.push('/')
    },

    // 选择视频
    async selectVideo(videoIndex) {
      const video = this.courseVideos[videoIndex]
      if (!video) return
      
      // const videoId = video.id
      // 检查视频是否已解锁
      if (!video.unlocked) {
        this.$message.warning('该视频尚未解锁，无法观看')
        return
      }

      // 直接使用API返回的视频信息，不需要额外调用详情接口
      this.currentVideoIndex = videoIndex
      this.showTest = false
      this.userAnswers = {}
      
      // 强制更新视频播放器
      this.$nextTick(() => {
        this.forceVideoUpdate()
      })
          
      console.log('选择视频:', video)
    },

    // 强制更新视频播放器
    forceVideoUpdate() {
      const video = this.$refs.videoPlayer
      if (video && this.currentContent && this.currentContent.videoUrl) {
        // 暂停当前播放
        video.pause()
        
        // 重新设置视频源
        const newSrc = this.getVideoUrl(this.currentContent.videoUrl)
        video.src = newSrc
        
        // 重新加载视频
        video.load()
        
        // 重新锁定播放速度
        this.lockVideoPlaybackRate()
        
        console.log('视频源已更新:', newSrc)
      }
    },

    // 选择测试
    selectTest() {
      this.showTest = true
      this.userAnswers = {}
    },

    // 课程类型数据的上一个/下一个导航
    async goToPrevious() {
      if (this.showTest) {
        // 从测试回到最后一个视频
        this.showTest = false
        this.currentVideoIndex = this.courseVideos.length - 1
        await this.selectVideo(this.currentVideoIndex)
      } else if (this.currentVideoIndex > 0) {
        // 上一个视频
        this.currentVideoIndex--
        await this.selectVideo(this.currentVideoIndex)
      }
      this.userAnswers = {}
    },

    async goToNext() {
      if (!this.showTest && this.currentVideoIndex < this.courseVideos.length - 1) {
        // 下一个视频
        const nextVideo = this.courseVideos[this.currentVideoIndex + 1];
        if (nextVideo && nextVideo.unlocked) {
          this.currentVideoIndex++
          await this.selectVideo(this.currentVideoIndex)
        } else {
          this.$message.warning('下一个视频尚未解锁，请先完成当前视频')
          return
        }
      } else if (!this.showTest && this.currentCourseTest) {
        // 从最后一个视频到测试
        this.showTest = true
      }
      this.userAnswers = {}
    },

    // 原有的章节和课程选择方法（用于兼容原有数据结构）
    selectChapter(chapterId) {
      this.$store.commit('setCurrentChapter', chapterId)
      const chapter = this.courseData.chapters.find(ch => ch.id === chapterId)
      this.$store.commit('setCurrentLesson', chapter.lessons[0].id)
    },

    selectLesson(lessonId) {
      this.$store.commit('setCurrentLesson', lessonId)
    },
    
    getChapterProgress(chapter) {
      return chapter.lessons.filter(lesson => 
        this.$store.state.learningProgress.completedLessons.includes(lesson.id)
      ).length
    },
    
    isLessonCompleted(lessonId) {
      return this.$store.state.learningProgress.completedLessons.includes(lessonId)
    },
    
    completeLesson() {
      this.$store.commit('completeLesson', this.currentLesson.id)
      this.$message.success('课程已完成！')
    },
    
    submitQuiz() {
      if (!this.isQuizComplete) {
        this.$message.warning('请完成所有题目')
        return
      }

      // 检查答案
      let correctCount = 0
      const questions = this.isFromNotice ? 
        (this.currentCourseTest ? this.currentCourseTest.questions : []) : 
        (this.currentLesson ? this.currentLesson.questions : [])

      if (!questions || questions.length === 0) {
        this.$message.error('题目数据不存在')
        return
      }

      questions.forEach(question => {
        if (this.userAnswers[question.id] === question.correctAnswer) {
          correctCount++
        }
      })

      const score = Math.round((correctCount / questions.length) * 100)

      if (score >= 60) {
        if (!this.isFromNotice) {
          this.$store.commit('completeLesson', this.currentLesson.id)
        }
        this.$message.success(`测试通过！得分：${score}分`)
      } else {
        this.$message.error(`测试未通过，得分：${score}分，请重新作答`)
      }
    },
    
    resetQuiz() {
      this.userAnswers = {}
      this.$message.info('已重置答案')
    },

    // 标记当前视频为已完成
    completeCurrentVideo() {
      if (this.isFromNotice && !this.showTest) {
        // 视频完成逻辑现在通过API解锁下一个视频来处理
        // this.$message.success('视频已标记为完成！')
      }
    },

    // 检查视频是否已完成
    isCurrentVideoCompleted() {
      if (!this.isFromNotice || this.showTest) return false
      const currentVideo = this.courseVideos[this.currentVideoIndex];
      return currentVideo ? currentVideo.unlocked : false;
    },

    // 检查视频是否已解锁
    isVideoUnlockedById(videoId) {
      // 使用API返回的unlocked字段
      const video = this.courseVideos.find(v => v.id === videoId);
      return video ? video.unlocked : false;
    },

    // 检查是否是有效的视频URL
    isValidVideoUrl(url) {
      if (!url) return false
      // 检查是否是真实的视频URL（不是示例URL）
      return !url.includes('example.com') && (
        url.includes('.mp4') ||
        url.includes('.webm') ||
        url.includes('.ogg') ||
        url.includes('youtube.com') ||
        url.includes('vimeo.com') ||
        url.includes('aliyuncs.com') || // 阿里云OSS
        url.includes('qcloud.com') || // 腾讯云
        url.includes('amazonaws.com') || // AWS S3
        url.startsWith('blob:') ||
        url.startsWith('data:') ||
        url.startsWith('http') ||
        url.startsWith('storage/') || // 支持相对路径
        url.includes('/video/') // 支持包含video路径的URL
      )
    },

    // 获取视频URL
    getVideoUrl(url) {
      if (!url) return ''
      // 如果是相对路径，添加API基础路径
      if (url.startsWith('storage/')) {
        return `https://bxxcx-ceshi.oss-cn-beijing.aliyuncs.com/${encodeURIComponent(url)}`
      }
      // 如果是完整的URL，直接返回
      if (url.startsWith('http')) {
        return url
      }
      // 其他情况，假设是相对路径
      return `https://bxxcx-ceshi.oss-cn-beijing.aliyuncs.com/${encodeURIComponent(url)}`
    },

    // 视频播放结束事件
    async onVideoEnded() {
      console.log('视频播放完成事件触发');
      this.$message.success('视频播放完成！')
      
      // 防止重复调用
      if (this._unlockingNextVideo) {
        console.log('正在解锁下一个视频，跳过重复调用');
        return;
      }
      
      try {
        this._unlockingNextVideo = true;
        await this.completeCurrentVideo()
        // 解锁下一个视频
        await this.unlockNextVideo()
      } finally {
        this._unlockingNextVideo = false;
      }
    },

    // 解锁下一个视频
    async unlockNextVideo() {
      try {
        const currentVideo = this.courseVideos[this.currentVideoIndex];
        if (!currentVideo) {
          console.error('解锁失败：当前视频不存在，currentVideoIndex:', this.currentVideoIndex);
          return;
        }

        console.log('开始解锁下一个视频，当前视频:', {
          id: currentVideo.id,
          title: currentVideo.title,
          sort: currentVideo.sort,
          index: this.currentVideoIndex
        });

        // 使用索引方式查找下一个视频，更可靠
        const nextVideoIndex = this.currentVideoIndex + 1;
        const nextVideo = this.courseVideos[nextVideoIndex];
        
        if (nextVideo) {
          console.log('找到下一个视频:', {
            id: nextVideo.id,
            title: nextVideo.title,
            sort: nextVideo.sort,
            index: nextVideoIndex,
            unlocked: nextVideo.unlocked
          });

          // 检查下一个视频是否已经解锁
          if (nextVideo.unlocked) {
            console.log(`视频 "${nextVideo.title}" (ID: ${nextVideo.id}) 已经解锁，无需重复解锁`);
            this.$message.success('下一个视频已解锁！');
            return;
          }
          
          // 验证下一个视频的ID是否有效
          if (!nextVideo.id) {
            console.error('解锁失败：下一个视频ID无效', nextVideo);
            this.$message.error('下一个视频ID无效，无法解锁');
            return;
          }

          // 下一个视频未解锁，调用解锁接口
          console.log(`正在调用解锁接口，视频ID: ${nextVideo.id}`);
          const response = await get(`/api.php/v1.video/unlock?id=${nextVideo.id}`);
          
          if (response.data && response.data.code === 0) {
            console.log(`成功解锁视频: "${nextVideo.title}" (ID: ${nextVideo.id})`);
            // 更新本地视频状态
            nextVideo.unlocked = true;
            this.$message.success('下一个视频已解锁！');
          } else if (response.data && response.data.code === 8100) {
            console.warn('解锁接口返回登录失效:', response.data);
            this.promptLoginExpired(response.data.msg || '登录令牌失效，请重新登录');
          } else {
            const errorMsg = response.data?.msg || '未知错误';
            console.error('解锁视频失败:', {
              videoId: nextVideo.id,
              videoTitle: nextVideo.title,
              error: errorMsg,
              response: response.data
            });
            this.$message.error(`解锁失败: ${errorMsg}`);
          }
        } else {
          // 没有下一个视频了，说明是最后一个视频，需要解锁考试
          console.log('当前是最后一个视频，准备解锁考试');
          await this.unlockExam();
        }
      } catch (error) {
        console.error('解锁视频失败，发生异常:', {
          error: error.message,
          stack: error.stack,
          currentVideoIndex: this.currentVideoIndex,
          courseVideosLength: this.courseVideos.length
        });
        this.$message.error('解锁视频时发生错误，请稍后重试');
      }
    },

    // 解锁考试
    async unlockExam() {
      // 最后一个视频看完后，直接提示学习已完成，可以开始考试
      console.log('最后一个视频播放完成，学习已完成');
      this.$message.success('学习已完成，可以开始考试！');
      this.examUnlocked = true;
    },

    // 获取当前课程类型对应的分类ID
    async getCurrentCategoryId() {
      if (!this.currentCourseType) return null;
      
      // 先确保课程分类已加载
      await this.loadCourseCategories();
      
      // 根据课程类型找到对应的分类ID
      if (this.currentCourseType.startsWith('2-')) {
        const index = parseInt(this.currentCourseType.split('-')[1]) - 1;
        if (this.courseCategories[index]) {
          return this.courseCategories[index].id;
        }
      } else {
        // 如果是课程名称，查找对应的分类
        const category = this.courseCategories.find(cat => cat.name === this.currentCourseType);
        if (category) {
          return category.id;
        }
      }
      
      return null;
    },

    // 原有视频播放结束事件
    onVideoEndedOriginal() {
      this.$message.success('视频播放完成！')
      if (this.currentLesson && this.currentLesson.id) {
        this.$store.commit('completeLesson', this.currentLesson.id)
      }
    },

    // 视频加载完成事件
    onVideoLoaded() {
      console.log('视频加载完成')
      // 禁用画中画功能
      this.disablePictureInPicture()
      // 使用Vue3简洁方式锁定播放速度
      this.lockVideoPlaybackRate()
    },
    
    // Vue3简洁方式锁定视频播放速度
    lockVideoPlaybackRate() {
      const video = this.$refs.videoPlayer || this.$refs.videoPlayerOriginal
      if (!video) {
        console.error('未找到视频元素')
        return
      }

      console.log('开始锁定视频播放速度，当前视频元素:', video)

      // 先尝试删除现有的属性定义
      try {
        delete video.playbackRate
      } catch (e) {
        console.log('无法删除现有属性定义')
      }

      // 锁定 playbackRate，检测到修改时暂停视频
      Object.defineProperty(video, 'playbackRate', {
        set: (value) => {
          console.log(`playbackRate setter 被调用，值: ${value}`)
          if (value !== 1.0) {
            console.warn(`检测到倍速修改：${value}，视频已暂停`)
            // 暂停视频而不是重置倍速
            video.pause()
            this.$message.warning('检测到倍速播放，视频已暂停，请使用正常速度观看')
            // 强制设置为1.0
            video._playbackRate = 1.0
          } else {
            video._playbackRate = value
          }
        },
        get: () => {
          // 检查组件是否已销毁
          if (this.isDestroyed) {
            return 1.0
          }
          const currentRate = video._playbackRate || 1.0
          // console.log(`playbackRate getter 被调用，返回: ${currentRate}`)
          return currentRate
        },
        configurable: true, // 原为 false，修复多次 define 导致的异常
        enumerable: true
      })

      // 初始化设置为正常速度
      video.playbackRate = 1.0
      video.defaultPlaybackRate = 1.0
      
      // 添加更频繁的检查
      const checkInterval = setInterval(() => {
        // 检查组件是否已销毁
        if (this.isDestroyed) {
          clearInterval(checkInterval)
          return
        }
        const currentRate = video.playbackRate
        if (currentRate !== 1.0) {
          console.warn(`定时检查发现倍速: ${currentRate}，暂停视频`)
          video.pause()
          this.$message.warning('检测到倍速播放，视频已暂停，请使用正常速度观看')
        }
      }, 100) // 每100ms检查一次
      
      // 添加基于时间进度的倍速检测
      this.addTimeBasedSpeedDetection(video)
      
      // 存储定时器引用
      video._speedCheckInterval = checkInterval
      
      console.log('视频播放速度监控已启用，检测到倍速将暂停视频')
    },
    
    // 基于时间进度的倍速检测
    addTimeBasedSpeedDetection(video) {
      let lastTime = 0
      let lastRealTime = Date.now()
      let timeJumpCount = 0
      
      const timeUpdateHandler = () => {
        const currentTime = video.currentTime
        const currentRealTime = Date.now()
        
        // 计算时间差
        const timeDiff = currentTime - lastTime
        const realTimeDiff = (currentRealTime - lastRealTime) / 1000 // 转换为秒
        
        // 如果视频在播放，检查时间进度是否异常
        if (!video.paused && timeDiff > 0 && realTimeDiff > 0) {
          const actualSpeed = timeDiff / realTimeDiff
          
          //计算播放速度
          if (actualSpeed > 1.2) {
            timeJumpCount++
            console.warn(`检测到异常播放速度: ${actualSpeed}，跳转次数: ${timeJumpCount}`)
            
            if (timeJumpCount >= 2) {
              console.error(`确认倍速播放，暂停视频`)
              video.pause()
              this.$message.error(`检测到倍速播放，视频已暂停！请使用正常速度观看`)
              timeJumpCount = 0
            }
          } else {
            timeJumpCount = 0
          }
        }
        
        lastTime = currentTime
        lastRealTime = currentRealTime
      }
      
      // 监听时间更新事件
      video.addEventListener('timeupdate', timeUpdateHandler)
      
      // 存储事件处理器引用，以便后续清理
      video._timeUpdateHandler = timeUpdateHandler
    },
    
    // 立即启动强制防护
    startImmediateProtection(video) {
      // 立即设置播放速率为1
      video.playbackRate = 1
      video.defaultPlaybackRate = 1
      
      // 重写playbackRate属性，检测到修改时暂停视频
      Object.defineProperty(video, 'playbackRate', {
        get: function() { return this._playbackRate || 1; },
        set: function(value) {
          if (value !== 1) {
            console.log('检测到倍速修改，视频已暂停:', value)
            this.pause()
            // 显示警告消息
            if (window.Vue && this.$message) {
              this.$message.warning('检测到倍速播放，视频已暂停，请使用正常速度观看')
            }
          }
          this._playbackRate = value
        },
        configurable: false,
        enumerable: true
      })
      
      // 重写defaultPlaybackRate属性
      Object.defineProperty(video, 'defaultPlaybackRate', {
        get: function() { return 1; },
        set: function(value) {
          console.log('尝试修改默认播放速率被阻止:', value)
          return
        },
        configurable: true, // 原为 false，修复多次 define 导致的异常
        enumerable: true
      })
      
      // 启动监控，检测到倍速时暂停视频
      const immediateProtectionInterval = setInterval(() => {
        if (video.playbackRate !== 1) {
          console.log('立即防护：检测到播放速率变化，暂停视频')
          video.pause()
        }
      }, 100) // 每100ms检查一次
      
      // 存储定时器引用
      video._immediateProtectionInterval = immediateProtectionInterval
      
      // 监听所有可能的事件
      const allEvents = [
        'ratechange', 'play', 'pause', 'loadstart', 'loadedmetadata', 
        'loadeddata', 'canplay', 'canplaythrough', 'seeking', 'seeked',
        'timeupdate', 'webkitplaybacktargetavailabilitychanged'
      ]
      
      allEvents.forEach(eventType => {
        video.addEventListener(eventType, () => {
          if (video.playbackRate !== 1) {
            console.log(`事件${eventType}触发，暂停视频`)
            video.pause()
          }
        }, true)
      })
    },



    // 强制设置视频播放器属性
    forceVideoControls() {
      const video = this.$refs.videoPlayer || this.$refs.videoPlayerOriginal
      if (video) {
        // 强制设置播放速率为1倍速
        video.playbackRate = 1
        video.defaultPlaybackRate = 1
        
        // 禁用全屏
        video.webkitSupportsFullscreen = false
        video.webkitEnterFullscreen = null
        
        // 禁用画中画
        video.requestPictureInPicture = null
        
        // 禁用倍速控制
        Object.defineProperty(video, 'playbackRate', {
          get: function() { return 1; },
          set: function() { /* 阻止设置 */ }
        });
        
        Object.defineProperty(video, 'defaultPlaybackRate', {
          get: function() { return 1; },
          set: function() { /* 阻止设置 */ }
        });
        
        // 监听键盘事件，阻止快捷键
        video.addEventListener('keydown', (e) => {
          if (e.key === 'f' || e.key === 'F') {
            e.preventDefault() // 阻止F键全屏
          }
          if (e.key === 'p' || e.key === 'P') {
            e.preventDefault() // 阻止P键画中画
          }
          // 阻止数字键改变倍速
          if (e.key >= '1' && e.key <= '9') {
            e.preventDefault()
          }
          // 阻止方向键快进/倒退
          if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            e.preventDefault()
            e.stopPropagation()
            e.stopImmediatePropagation()
            return false
          }
        }, true) // 使用捕获模式
        
        // 监听鼠标事件，阻止右键菜单中的倍速选项
        video.addEventListener('contextmenu', (e) => {
          e.preventDefault()
          return false
        })
        
        // 禁用进度条拖拽功能（核心）
        this.disableProgressDrag(video)
        
        // 动态移除倍速相关的DOM元素
        this.removePlaybackRateElements(video)
        
        // 监听DOM变化，自动移除新添加的倍速元素
        this.observeDOMChanges(video)
        
        // 完全禁用方向键功能
        this.disableArrowKeysCompletely(video)
        
        // 防止插件控制视频速度
        this.preventPluginSpeedControl(video)
      }
    },
    
    // 禁用进度条拖拽功能 -- 恢复并实现
    disableProgressDrag(video) {
      // 屏蔽HTML5原生进度条的mousedown/touchstart事件
      // 主要拦截 seek 相关操作
      video.addEventListener('seeking', function(e) {
        // 直接回退到原始进度，禁止跳转
        video.currentTime = video._lastKnownTime || 0
        e.stopImmediatePropagation();
        e.preventDefault();
        return false;
      }, true);
      // 记录正常播放时的时间
      video.addEventListener('timeupdate', function() {
        video._lastKnownTime = video.currentTime
      })
      // 禁止所有通过 currentTime 改变进度的可能（setter加锁）
      let currentTimeDescriptor = Object.getOwnPropertyDescriptor(HTMLMediaElement.prototype, 'currentTime')
      if (currentTimeDescriptor && currentTimeDescriptor.set) {
        Object.defineProperty(video, 'currentTime', {
          get: currentTimeDescriptor.get,
          set: function(value) {
            // 只允许程序内部（可设置token变量）允许跳转，否则锁定
            if (this._allowTimeChange) {
              currentTimeDescriptor.set.call(this, value)
            } else {
              // 强制回退
              currentTimeDescriptor.set.call(this, this._lastKnownTime || 0)
            }
          },
          configurable: false, // 禁止后续修改该属性配置
          enumerable: true
        })
      }
      // 尽可能拦截UI层拖拽（部分浏览器生效）
      video.addEventListener('mousedown', function(e) {
        // 拖动进度条时，直接阻断
        if (e.target && e.target.nodeName.includes('TIMELINE')) {
          e.stopImmediatePropagation();
          e.preventDefault();
          return false;
        }
      }, true)
    },
    
    // 强制禁用进度条拖拽
    // forceDisableProgressDrag(video) {
    //   ...方法体全部注释或删除...
    // },
    
    // 判断是否是进度条元素
    // isProgressElement(element) {
    //   ...方法体全部注释或删除...
    // },
    
    // 移除倍速相关的DOM元素
    removePlaybackRateElements(video) {
      // 延迟执行，确保DOM完全加载
      setTimeout(() => {
        // 查找并移除所有倍速相关的元素
        const selectors = [
          '[class*="playback-rate"]',
          '[class*="rate"]',
          '[class*="speed"]',
          '[title*="倍速"]',
          '[title*="速度"]',
          '[aria-label*="倍速"]',
          '[aria-label*="速度"]'
        ]
        
        selectors.forEach(selector => {
          const elements = video.parentElement.querySelectorAll(selector)
          elements.forEach(el => {
            el.style.display = 'none'
            el.style.visibility = 'hidden'
            el.style.opacity = '0'
            el.style.pointerEvents = 'none'
            el.style.width = '0'
            el.style.height = '0'
            el.style.overflow = 'hidden'
          })
        })
        
        // 查找包含倍速文本的元素
        const allElements = video.parentElement.querySelectorAll('*')
        allElements.forEach(el => {
          if (el.textContent && (
            el.textContent.includes('0.5x') ||
            el.textContent.includes('1x') ||
            el.textContent.includes('1.5x') ||
            el.textContent.includes('2x') ||
            el.textContent.includes('倍速') ||
            el.textContent.includes('速度')
          )) {
            el.style.display = 'none'
            el.style.visibility = 'hidden'
          }
        })
      }, 100)
    },
    
    // 监听DOM变化，自动移除新添加的倍速元素
    observeDOMChanges(video) {
      if (!video.parentElement) return
      
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                // 检查新添加的元素是否包含倍速相关内容
                if (this.isPlaybackRateElement(node)) {
                  node.style.display = 'none'
                  node.style.visibility = 'hidden'
                  node.style.opacity = '0'
                  node.style.pointerEvents = 'none'
                }
              }
            })
          }
        })
      })
      
      observer.observe(video.parentElement, {
        childList: true,
        subtree: true
      })
    },
    
    // 判断元素是否包含倍速相关内容
    isPlaybackRateElement(element) {
      // 检查class名
      if (element.className && (
        element.className.includes('playback-rate') ||
        element.className.includes('rate') ||
        element.className.includes('speed')
      )) {
        return true
      }
      
      // 检查文本内容
      if (element.textContent && (
        element.textContent.includes('0.5x') ||
        element.textContent.includes('1x') ||
        element.textContent.includes('1.5x') ||
        element.textContent.includes('2x') ||
        element.textContent.includes('倍速') ||
        element.textContent.includes('速度')
      )) {
        return true
      }
      
      // 检查title属性
      if (element.title && (
        element.title.includes('倍速') ||
        element.title.includes('速度')
      )) {
        return true
      }
      
      return false
    },

    // 完全禁用方向键功能
    disableArrowKeysCompletely(video) {
      // 重写视频元素的 seek 相关方法
      const originalSeek = video.seek
      if (originalSeek) {
        video.seek = function() {
          // 阻止任何 seek 操作
          return
        }
      }
      
      // 重写 currentTime 的 setter
      let currentTimeDescriptor = Object.getOwnPropertyDescriptor(HTMLMediaElement.prototype, 'currentTime')
      if (currentTimeDescriptor && currentTimeDescriptor.set) {
        const originalSetCurrentTime = currentTimeDescriptor.set
        Object.defineProperty(video, 'currentTime', {
          get: currentTimeDescriptor.get,
          set: function(value) {
            // 只允许通过程序设置，不允许通过键盘操作
            if (this._allowTimeChange) {
              originalSetCurrentTime.call(this, value)
            }
          }
        })
      }
      
      // 监听所有可能的键盘事件
      const keyEvents = ['keydown', 'keyup', 'keypress']
      keyEvents.forEach(eventType => {
        video.addEventListener(eventType, (e) => {
          if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            e.preventDefault()
            e.stopPropagation()
            e.stopImmediatePropagation()
            return false
          }
        }, true)
      })
      
      // 监听视频的 seeked 事件并阻止
      video.addEventListener('seeked', (e) => {
        e.preventDefault()
        e.stopPropagation()
        return false
      }, true)
      
      // 定期检查并重置 currentTime（如果被意外修改）
      setInterval(() => {
        if (video._lastKnownTime && Math.abs(video.currentTime - video._lastKnownTime) > 1) {
          video.currentTime = video._lastKnownTime
        }
        video._lastKnownTime = video.currentTime
      }, 100)
    },

    // 防止插件控制视频速度
    preventPluginSpeedControl(video) {
      // 1. 使用 Proxy 代理整个视频对象，拦截所有属性访问
      const videoProxy = new Proxy(video, {
        get(target, prop) {
          if (prop === 'playbackRate' || prop === 'defaultPlaybackRate') {
            return 1
          }
          return target[prop]
        },
        set(target, prop, value) {
          if (prop === 'playbackRate' || prop === 'defaultPlaybackRate') {
            console.log('Proxy拦截到播放速率修改尝试:', prop, value)
            return true // 阻止设置
          }
          target[prop] = value
          return true
        }
      })
      
      // 存储代理对象以便后续使用
      video._videoProxy = videoProxy
      
      // 2. 重写 playbackRate 属性，使其无法被修改
      let playbackRateDescriptor = Object.getOwnPropertyDescriptor(HTMLMediaElement.prototype, 'playbackRate')
      if (playbackRateDescriptor) {
        Object.defineProperty(video, 'playbackRate', {
          get: function() { return 1; },
          set: function(value) {
            // 完全阻止设置，始终返回1
            console.log('尝试修改播放速率被阻止:', value)
            return
          },
          configurable: false,
          enumerable: true
        })
      }
      
      // 3. 重写所有可能被插件使用的方法
      const methodsToOverride = [
        'play', 'pause', 'load', 'canPlayType', 'addTextTrack',
        'webkitPlaybackTargetAvailabilityChanged'
      ]
      
      methodsToOverride.forEach(methodName => {
        if (video[methodName] && typeof video[methodName] === 'function') {
          const originalMethod = video[methodName]
          video[methodName] = function(...args) {
            const result = originalMethod.apply(this, args)
            // 确保方法调用后播放速率仍然是1
            this.playbackRate = 1
            this.defaultPlaybackRate = 1
            return result
          }
        }
      })
      
      // 2. 重写 defaultPlaybackRate 属性
      let defaultPlaybackRateDescriptor = Object.getOwnPropertyDescriptor(HTMLMediaElement.prototype, 'defaultPlaybackRate')
      if (defaultPlaybackRateDescriptor) {
        Object.defineProperty(video, 'defaultPlaybackRate', {
          get: function() { return 1; },
          set: function(value) {
            console.log('尝试修改默认播放速率被阻止:', value)
            return
          },
          configurable: true, // 原为 false，修复多次 define 导致的异常
          enumerable: true
        })
      }
      
      // 3. 监听所有可能改变播放速率的事件并立即重置
      const rateChangeEvents = [
        'ratechange', 
        'webkitplaybacktargetavailabilitychanged',
        'loadedmetadata', 
        'canplay', 
        'play', 
        'pause',
        'seeking',
        'seeked',
        'timeupdate'
      ]
      
      rateChangeEvents.forEach(eventType => {
        video.addEventListener(eventType, () => {
          if (video.playbackRate !== 1) {
            video.playbackRate = 1
            video.defaultPlaybackRate = 1
            console.log(`在${eventType}事件中检测到播放速率被修改，已重置`)
          }
        }, true)
      })
      
      // 4. 使用 MutationObserver 监控DOM变化，防止插件注入控制元素
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                // 检查是否包含速度控制相关的元素
                if (this.isSpeedControlElement(node)) {
                  node.remove()
                  console.log('检测到插件注入的速度控制元素，已移除')
                }
              }
            })
          }
        })
      })
      
      observer.observe(video.parentElement || document.body, {
        childList: true,
        subtree: true
      })
      
      // 5. 重写可能被插件使用的方法
      const originalPlay = video.play
      video.play = function() {
        const result = originalPlay.call(this)
        // 确保播放时速率是1
        this.playbackRate = 1
        this.defaultPlaybackRate = 1
        return result
      }
      
      // 6. 定期强制重置（作为最后防线）
      const forceResetInterval = setInterval(() => {
        if (video.playbackRate !== 1) {
          video.playbackRate = 1
          video.defaultPlaybackRate = 1
          console.log('强制重置播放速率为1倍速')
        }
      }, 50) // 每50ms检查一次
      
      // 存储定时器引用以便清理
      video._forceResetInterval = forceResetInterval
      
      // 7. 重写 Object.defineProperty 方法，防止插件绕过
      const originalDefineProperty = Object.defineProperty
      Object.defineProperty = function(obj, prop, descriptor) {
        if (obj === video && (prop === 'playbackRate' || prop === 'defaultPlaybackRate')) {
          console.log('阻止插件重写播放速率属性')
          return obj
        }
        return originalDefineProperty.call(this, obj, prop, descriptor)
      }
      
      // 8. 重写 Object.getOwnPropertyDescriptor 方法
      const originalGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor
      Object.getOwnPropertyDescriptor = function(obj, prop) {
        if (obj === video && (prop === 'playbackRate' || prop === 'defaultPlaybackRate')) {
          return {
            get: function() { return 1; },
            set: function() { return; },
            configurable: false,
            enumerable: true
          }
        }
        return originalGetOwnPropertyDescriptor.call(this, obj, prop)
      }
      
      // 9. 监听所有可能的全局事件
      const globalEvents = [
        'ratechange', 'playbackratechange', 'speedchange', 
        'playbackRateChange', 'videoSpeedChange'
      ]
      
      globalEvents.forEach(eventType => {
        document.addEventListener(eventType, (e) => {
          if (e.target === video) {
            e.preventDefault()
            e.stopPropagation()
            video.playbackRate = 1
            console.log(`阻止了全局${eventType}事件`)
          }
        }, true)
      })
      
      // 10. 重写可能被插件使用的原型方法
      const originalHTMLMediaElementPlay = HTMLMediaElement.prototype.play
      HTMLMediaElement.prototype.play = function() {
        const result = originalHTMLMediaElementPlay.call(this)
        if (this === video) {
          this.playbackRate = 1
          this.defaultPlaybackRate = 1
        }
        return result
      }
      
      // 7. 监听 window 对象上的事件，防止全局插件控制
      const globalRateChangeHandler = (e) => {
        if (e.target === video && e.detail && e.detail.playbackRate) {
          e.preventDefault()
          e.stopPropagation()
          video.playbackRate = 1
          console.log('阻止了全局播放速率修改事件')
        }
      }
      
      window.addEventListener('ratechange', globalRateChangeHandler, true)
      window.addEventListener('playbackratechange', globalRateChangeHandler, true)
      
      // 8. 重写可能被插件调用的原生方法
      if (video.webkitPlaybackTargetAvailabilityChanged) {
        video.webkitPlaybackTargetAvailabilityChanged = function() {
          this.playbackRate = 1
          this.defaultPlaybackRate = 1
        }
      }
      
      // 11. 使用 MutationObserver 监控所有对视频元素的修改
      const videoObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes') {
            if (mutation.attributeName === 'playbackrate' || 
                mutation.attributeName === 'data-playback-rate') {
              video.playbackRate = 1
              console.log('检测到属性修改，已重置播放速率')
            }
          }
        })
      })
      
      videoObserver.observe(video, {
        attributes: true,
        attributeFilter: ['playbackrate', 'data-playback-rate']
      })
      
      // 12. 重写所有可能被插件使用的 setter
      const settersToOverride = [
        'currentTime', 'volume', 'muted', 'paused'
      ]
      
      settersToOverride.forEach(prop => {
        const descriptor = Object.getOwnPropertyDescriptor(HTMLMediaElement.prototype, prop)
        if (descriptor && descriptor.set) {
          const originalSetter = descriptor.set
          Object.defineProperty(video, prop, {
            get: descriptor.get,
            set: function(value) {
              originalSetter.call(this, value)
              // 确保任何属性修改后播放速率仍然是1
              this.playbackRate = 1
              this.defaultPlaybackRate = 1
            }
          })
        }
      })
      
      // 13. 使用 Object.freeze 冻结关键属性
      try {
        Object.freeze(video.playbackRate)
        Object.freeze(video.defaultPlaybackRate)
      } catch (e) {
        console.log('无法冻结属性，使用其他方法保护')
      }
      
      // 14. 重写可能被插件使用的全局函数
      if (window.HTMLMediaElement) {
        const originalCreateElement = document.createElement
        document.createElement = function(tagName) {
          const element = originalCreateElement.call(this, tagName)
          if (tagName.toLowerCase() === 'video' && element === video) {
            // 为这个特定的视频元素添加额外保护
            element._isProtected = true
          }
          return element
        }
      }
      
      // 15. 重写所有可能被脚本使用的全局对象和方法
      this.overrideGlobalObjects()
      
      // 16. 添加内存级别的保护
      this.addMemoryProtection(video)
      
      // 17. 监控所有可能的修改尝试
      this.monitorAllChanges(video)
      
      // 18. 重写所有可能被脚本调用的原生方法
      this.overrideNativeMethods(video)
      
      // 19. 针对 Global Speed 等特定插件的防护
      this.preventGlobalSpeedPlugin(video)
    },
    
    // 针对 Global Speed 等特定插件的防护
    preventGlobalSpeedPlugin(video) {
      // 1. 检测并阻止 Global Speed 插件的常见方法
      const globalSpeedMethods = [
        'setPlaybackRate', 'setSpeed', 'setRate', 'changeSpeed',
        'applySpeed', 'updateSpeed', 'setVideoSpeed'
      ]
      
      globalSpeedMethods.forEach(methodName => {
        if (video[methodName]) {
          video[methodName] = function() {
            console.log(`阻止了${methodName}方法调用`)
            return
          }
        }
      })
      
      // 2. 重写可能被 Global Speed 使用的属性
      const globalSpeedProperties = [
        'speed', 'rate', 'velocity', 'tempo', 'pace'
      ]
      
      globalSpeedProperties.forEach(prop => {
        Object.defineProperty(video, prop, {
          get: function() { return 1; },
          set: function() {
            console.log(`阻止了${prop}属性修改`)
            return
          },
          configurable: true, // 原为 false，修复多次 define 导致的异常
          enumerable: true
        })
      })
      
      // 3. 监听并阻止 Global Speed 插件可能使用的事件
      const globalSpeedEvents = [
        'speedchange', 'ratechange', 'playbackratechange',
        'globalspeedchange', 'speedcontrol', 'ratecontrol'
      ]
      
      globalSpeedEvents.forEach(eventType => {
        video.addEventListener(eventType, (e) => {
          e.preventDefault()
          e.stopPropagation()
          video.playbackRate = 1
          console.log(`阻止了${eventType}事件`)
        }, true)
      })
      
      // 4. 重写可能被 Global Speed 使用的全局函数
      if (window.globalSpeed) {
        window.globalSpeed = undefined
      }
      
      if (window.setGlobalSpeed) {
        window.setGlobalSpeed = function() {
          console.log('阻止了setGlobalSpeed函数调用')
          return
        }
      }
      
      // 5. 监控并阻止 Global Speed 插件可能注入的DOM元素
      const globalSpeedSelectors = [
        '[class*="global-speed"]',
        '[class*="speed-control"]',
        '[class*="rate-control"]',
        '[id*="global-speed"]',
        '[id*="speed-control"]',
        '[data-global-speed]',
        '[data-speed-control]'
      ]
      
      const globalSpeedObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                globalSpeedSelectors.forEach(selector => {
                  if (node.matches && node.matches(selector)) {
                    node.remove()
                    console.log('移除了Global Speed插件注入的元素')
                  }
                })
              }
            })
          }
        })
      })
      
      globalSpeedObserver.observe(document.body, {
        childList: true,
        subtree: true
      })
      
      // 6. 重写可能被 Global Speed 使用的原型方法
      const originalHTMLMediaElementPlay = HTMLMediaElement.prototype.play
      HTMLMediaElement.prototype.play = function() {
        const result = originalHTMLMediaElementPlay.call(this)
        if (this === video) {
          // 强制重置播放速率
          this.playbackRate = 1
          this.defaultPlaybackRate = 1
          console.log('在play方法中重置播放速率')
        }
        return result
      }
      
      // 7. 监听并阻止 Global Speed 插件可能使用的消息传递
      const originalPostMessage = window.postMessage
      window.postMessage = function(message, targetOrigin) {
        if (typeof message === 'object' && message.type && (
          message.type.includes('speed') || 
          message.type.includes('rate') ||
          message.type.includes('playback')
        )) {
          console.log('阻止了可能的速度控制消息')
          return
        }
        return originalPostMessage.call(this, message, targetOrigin)
      }
      
      // 8. 重写可能被 Global Speed 使用的存储API
      const originalLocalStorageSetItem = localStorage.setItem
      localStorage.setItem = function(key, value) {
        if (key.includes('speed') || key.includes('rate') || key.includes('playback')) {
          console.log('阻止了速度相关的localStorage设置')
          return
        }
        return originalLocalStorageSetItem.call(this, key, value)
      }
      
      // 9. 定期检查并重置可能被 Global Speed 修改的属性
      const globalSpeedCheckInterval = setInterval(() => {
        if (video.playbackRate !== 1) {
          video.playbackRate = 1
          video.defaultPlaybackRate = 1
          console.log('检测到Global Speed插件修改，已重置')
        }
        
        // 检查是否有Global Speed相关的DOM元素
        const globalSpeedElements = document.querySelectorAll(
          globalSpeedSelectors.join(', ')
        )
        globalSpeedElements.forEach(element => {
          element.remove()
          console.log('移除了Global Speed相关元素')
        })
      }, 100) // 每100ms检查一次
      
      // 存储定时器引用
      video._globalSpeedCheckInterval = globalSpeedCheckInterval
    },
    
    // 重写全局对象和方法
    overrideGlobalObjects() {
      // 重写 window 对象上的所有可能方法
      const windowMethods = [
        'setTimeout', 'setInterval', 'requestAnimationFrame',
        'addEventListener', 'removeEventListener'
      ]
      
      windowMethods.forEach(methodName => {
        if (window[methodName]) {
          const originalMethod = window[methodName]
          window[methodName] = function(...args) {
            // 检查是否包含视频速率相关的代码
            const codeString = args.join('')
            if (codeString.includes('playbackRate') || 
                codeString.includes('defaultPlaybackRate') ||
                codeString.includes('video.playbackRate')) {
              console.log('阻止了可能修改播放速率的脚本执行')
              return
            }
            return originalMethod.apply(this, args)
          }
        }
      })
      
      // 重写 eval 和 Function 构造函数
      const originalEval = window.eval
      window.eval = function(code) {
        if (typeof code === 'string' && (
          code.includes('playbackRate') || 
          code.includes('defaultPlaybackRate') ||
          code.includes('video.playbackRate')
        )) {
          console.log('阻止了可能修改播放速率的eval执行')
          return
        }
        return originalEval.call(this, code)
      }
      
      const originalFunction = window.Function
      window.Function = function(...args) {
        const code = args[args.length - 1]
        if (typeof code === 'string' && (
          code.includes('playbackRate') || 
          code.includes('defaultPlaybackRate') ||
          code.includes('video.playbackRate')
        )) {
          console.log('阻止了可能修改播放速率的Function构造')
          return function() {}
        }
        return originalFunction.apply(this, args)
      }
    },
    
    // 添加内存级别的保护
    addMemoryProtection(video) {
      // 使用 WeakMap 存储原始值
      const originalValues = new WeakMap()
      originalValues.set(video, {
        playbackRate: 1,
        defaultPlaybackRate: 1
      })
      
      // 重写所有可能修改播放速率的方法
      const methodsToProtect = [
        'play', 'pause', 'load', 'canPlayType', 'addTextTrack',
        'webkitPlaybackTargetAvailabilityChanged', 'seekTo',
        'setCurrentTime', 'setPlaybackRate'
      ]
      
      methodsToProtect.forEach(methodName => {
        if (video[methodName] && typeof video[methodName] === 'function') {
          const originalMethod = video[methodName]
          video[methodName] = function(...args) {
            const result = originalMethod.apply(this, args)
            // 强制重置播放速率
            this.playbackRate = 1
            this.defaultPlaybackRate = 1
            return result
          }
        }
      })
      
      // 使用 Object.defineProperty 重写所有相关属性
      const propertiesToProtect = [
        'playbackRate', 'defaultPlaybackRate', 'currentTime',
        'volume', 'muted', 'paused'
      ]
      
      propertiesToProtect.forEach(prop => {
        const descriptor = Object.getOwnPropertyDescriptor(HTMLMediaElement.prototype, prop)
        if (descriptor) {
          Object.defineProperty(video, prop, {
            get: function() {
              if (prop === 'playbackRate' || prop === 'defaultPlaybackRate') {
                return 1
              }
              return descriptor.get ? descriptor.get.call(this) : this[prop]
            },
            set: function(value) {
              if (prop === 'playbackRate' || prop === 'defaultPlaybackRate') {
                console.log('阻止了播放速率修改尝试')
                return
              }
              if (descriptor.set) {
                descriptor.set.call(this, value)
              } else {
                this[prop] = value
              }
              // 确保播放速率始终为1
              this.playbackRate = 1
              this.defaultPlaybackRate = 1
            },
            configurable: false,
            enumerable: true
          })
        }
      })
    },
    
    // 监控所有可能的修改尝试
    monitorAllChanges(video) {
      // 使用 Proxy 监控所有属性访问
      const videoProxy = new Proxy(video, {
        get(target, prop) {
          if (prop === 'playbackRate' || prop === 'defaultPlaybackRate') {
            return 1
          }
          return target[prop]
        },
        set(target, prop, value) {
          if (prop === 'playbackRate' || prop === 'defaultPlaybackRate') {
            console.log('Proxy拦截到播放速率修改尝试:', prop, value)
            return true
          }
          target[prop] = value
          return true
        },
        defineProperty(target, prop, descriptor) {
          if (prop === 'playbackRate' || prop === 'defaultPlaybackRate') {
            console.log('阻止了播放速率属性重定义')
            return true
          }
          return Object.defineProperty(target, prop, descriptor)
        }
      })
      
      // 存储代理对象
      video._protectedProxy = videoProxy
      
      // 监控所有可能的事件
      const eventsToMonitor = [
        'ratechange', 'playbackratechange', 'speedchange',
        'playbackRateChange', 'videoSpeedChange', 'timeupdate',
        'seeking', 'seeked', 'play', 'pause', 'loadstart',
        'loadedmetadata', 'loadeddata', 'canplay', 'canplaythrough'
      ]
      
      eventsToMonitor.forEach(eventType => {
        video.addEventListener(eventType, () => {
          if (video.playbackRate !== 1) {
            video.playbackRate = 1
            video.defaultPlaybackRate = 1
            console.log(`在${eventType}事件中重置播放速率`)
          }
        }, true)
      })
      
      // 使用 MutationObserver 监控所有变化
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes') {
            const attributeName = mutation.attributeName
            if (attributeName && (
              attributeName.includes('rate') || 
              attributeName.includes('speed') ||
              attributeName.includes('playback')
            )) {
              video.playbackRate = 1
              video.defaultPlaybackRate = 1
              console.log('检测到属性变化，已重置播放速率')
            }
          }
        })
      })
      
      observer.observe(video, {
        attributes: true,
        attributeOldValue: true,
        attributeFilter: ['playbackrate', 'data-playback-rate', 'data-speed']
      })
    },
    
    // 重写所有可能被脚本调用的原生方法
    overrideNativeMethods(video) {
      // 重写所有可能被脚本使用的全局方法
      const globalMethods = [
        'setTimeout', 'setInterval', 'requestAnimationFrame',
        'setImmediate', 'queueMicrotask'
      ]
      
      globalMethods.forEach(methodName => {
        if (window[methodName]) {
          const originalMethod = window[methodName]
          window[methodName] = function(...args) {
            // 检查回调函数是否包含播放速率修改
            const callback = args[0]
            if (typeof callback === 'function') {
              const callbackString = callback.toString()
              if (callbackString.includes('playbackRate') || 
                  callbackString.includes('defaultPlaybackRate')) {
                console.log(`阻止了可能修改播放速率的${methodName}回调`)
                return
              }
            }
            return originalMethod.apply(this, args)
          }
        }
      })
      
      // 重写所有可能被脚本使用的事件监听方法
      const originalAddEventListener = EventTarget.prototype.addEventListener
      EventTarget.prototype.addEventListener = function(type, listener, options) {
        if (this === video && (
          type.includes('rate') || 
          type.includes('speed') ||
          type.includes('playback')
        )) {
          console.log('阻止了播放速率相关的事件监听器')
          return
        }
        return originalAddEventListener.call(this, type, listener, options)
      }
      
      // 重写所有可能被脚本使用的属性访问方法
      const originalGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor
      Object.getOwnPropertyDescriptor = function(obj, prop) {
        if (obj === video && (prop === 'playbackRate' || prop === 'defaultPlaybackRate')) {
          return {
            get: function() { return 1; },
            set: function() { return; },
            configurable: false,
            enumerable: true
          }
        }
        return originalGetOwnPropertyDescriptor.call(this, obj, prop)
      }
    },
    
    // 检查是否是速度控制元素
    isSpeedControlElement(element) {
      // 检查class名
      if (element.className && (
        element.className.includes('playback-rate') ||
        element.className.includes('rate') ||
        element.className.includes('speed') ||
        element.className.includes('velocity')
      )) {
        return true
      }
      
      // 检查文本内容
      if (element.textContent && (
        element.textContent.includes('0.5x') ||
        element.textContent.includes('1x') ||
        element.textContent.includes('1.5x') ||
        element.textContent.includes('2x') ||
        element.textContent.includes('倍速') ||
        element.textContent.includes('速度') ||
        element.textContent.includes('Rate')
      )) {
        return true
      }
      
      // 检查属性
      if (element.getAttribute && (
        element.getAttribute('data-rate') ||
        element.getAttribute('data-speed') ||
        element.getAttribute('data-playback-rate')
      )) {
        return true
      }
      
      return false
    },

    // 禁用画中画功能
    disablePictureInPicture() {
      const video = this.$refs.videoPlayer || this.$refs.videoPlayerOriginal
      if (video) {
        // 禁用画中画
        video.disablePictureInPicture = true
        
        // 监听画中画事件并阻止
        video.addEventListener('enterpictureinpicture', () => {
          return false
        })
        
        // 禁用全屏
        video.addEventListener('webkitbeginfullscreen', () => {
          return false
        })
        
        // 禁用倍速控制
        video.addEventListener('ratechange', () => {
          if (video.playbackRate !== 1) {
            video.playbackRate = 1
          }
        })
        
        // 监听播放速率变化
        video.addEventListener('webkitplaybacktargetavailabilitychanged', () => {
          video.playbackRate = 1
        })
        
        // 设置播放速率为1倍速
        video.playbackRate = 1
        
        // 禁用默认的倍速控制
        video.defaultPlaybackRate = 1
        video.playbackRate = 1
        
        // 定期检查，检测到倍速时暂停视频
        const rateCheckInterval = setInterval(() => {
          if (video.playbackRate !== 1) {
            console.log('检测到播放速率被修改，视频已暂停')
            video.pause()
            this.$message.warning('检测到倍速播放，视频已暂停，请使用正常速度观看')
          }
        }, 50) // 每50ms检查一次
        
        // 存储定时器引用
        video._rateCheckInterval = rateCheckInterval
        
        // 监听所有可能改变播放速率的事件
        const events = ['ratechange', 'webkitplaybacktargetavailabilitychanged', 'loadedmetadata', 'canplay', 'play']
        events.forEach(eventType => {
          video.addEventListener(eventType, () => {
            if (video.playbackRate !== 1) {
              console.log(`事件${eventType}触发，检测到倍速，视频已暂停`)
              video.pause()
              this.$message.warning('检测到倍速播放，视频已暂停，请使用正常速度观看')
            }
          })
        })
        
        // 添加更强的事件阻止机制
        video.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            e.preventDefault()
            e.stopPropagation()
            e.stopImmediatePropagation()
            return false
          }
        }, true)
        
        // 添加 keyup 事件阻止
        video.addEventListener('keyup', (e) => {
          if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            e.preventDefault()
            e.stopPropagation()
            e.stopImmediatePropagation()
            return false
          }
        }, true)
        
        // 移除画中画相关的事件监听器
        video.removeEventListener('enterpictureinpicture', null)
      }
    },

    // 移除simulateVideoEnd方法，不再需要

    // 加载课程分类
    async loadCourseCategories() {
      if (this.courseCategories.length > 0) {
        return;
      }
      
      try {
        const response = await get('/api.php/v1.video/category');
        if (response.data && response.data.code === 0) {
          this.courseCategories = response.data.data;
        } else {
          console.error('获取课程分类失败:', response.data?.msg || '未知错误');
        }
      } catch (error) {
        console.error('获取课程分类失败:', error);
      }
    },

    // 处理全局键盘事件，禁用方向键
    handleGlobalKeydown(e) {
      // 检查是否有视频元素存在
      const video = this.$refs.videoPlayer || this.$refs.videoPlayerOriginal
      if (video) {
        // 禁用方向键快进/倒退
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          e.preventDefault()
          e.stopPropagation()
          e.stopImmediatePropagation()
          return false
        }
      }
    },
    
    // 启动全局防护机制
    startGlobalProtection() {
      // 全局监控所有视频元素
      const globalVideoMonitor = setInterval(() => {
        const videos = document.querySelectorAll('video')
        videos.forEach(video => {
          if (video.playbackRate !== 1) {
            console.log('全局防护：检测到视频播放速率变化，强制重置')
            video.playbackRate = 1
            video.defaultPlaybackRate = 1
          }
        })
      }, 20) // 每20ms检查一次
      
      // 存储全局监控定时器
      this._globalVideoMonitor = globalVideoMonitor
      
      // 重写全局的HTMLMediaElement原型
      this.overrideGlobalHTMLMediaElement()
      
      // 监听所有可能的全局事件
      this.listenGlobalEvents()
    },
    
    // 重写全局的HTMLMediaElement原型
    overrideGlobalHTMLMediaElement() {
      // 重写playbackRate属性
      Object.defineProperty(HTMLMediaElement.prototype, 'playbackRate', {
        get: function() { return 1; },
        set: function(value) {
          console.log('全局防护：阻止播放速率修改', value)
          return
        },
        configurable: true, // 原为 false，修复多次 define 导致的异常
        enumerable: true
      })
      
      // 重写defaultPlaybackRate属性
      Object.defineProperty(HTMLMediaElement.prototype, 'defaultPlaybackRate', {
        get: function() { return 1; },
        set: function(value) {
          console.log('全局防护：阻止默认播放速率修改', value)
          return
        },
        configurable: true, // 原为 false，修复多次 define 导致的异常
        enumerable: true
      })
    },
    
    // 监听全局事件
    listenGlobalEvents() {
      // 监听所有可能的全局事件
      const globalEvents = [
        'ratechange', 'playbackratechange', 'speedchange',
        'playbackRateChange', 'videoSpeedChange'
      ]
      
      globalEvents.forEach(eventType => {
        document.addEventListener(eventType, (e) => {
          if (e.target && e.target.tagName === 'VIDEO') {
            e.preventDefault()
            e.stopPropagation()
            e.target.playbackRate = 1
            // console.log(`全局防护：阻止了${eventType}事件`)
          }
        }, true)
      })
    },
    
    // 启动强力倍速检测
    startAggressiveSpeedDetection() {
      // console.log('启动强力倍速检测')
      
      // 全局监控所有视频元素 - 使用更直接的方法
      const globalSpeedMonitor = setInterval(() => {
        // 检查组件是否已销毁
        if (this.isDestroyed) {
          clearInterval(globalSpeedMonitor)
          return
        }
        
        const videos = document.querySelectorAll('video')
        videos.forEach(video => {
          // 直接访问原生属性，绕过我们的getter
          const nativeRate = video._playbackRate || video.playbackRate
          const actualRate = video.getAttribute('data-playback-rate') || nativeRate
          
          // console.log(`检查视频播放速度 - 原生值: ${nativeRate}, 实际值: ${actualRate}`)
          
          // 检查多种可能的倍速值
          if (nativeRate !== 1.0 || actualRate !== 1.0 || video.playbackRate !== 1.0) {
            console.warn(`强力检测发现倍速 - 原生: ${nativeRate}, 实际: ${actualRate}, 属性: ${video.playbackRate}`)
            video.pause()
            this.$message.error(`检测到倍速播放，视频已暂停！请使用正常速度观看`)
            
            // 强制重置为1.0
            try {
              video.playbackRate = 1.0
              video._playbackRate = 1.0
              video.setAttribute('data-playback-rate', '1.0')
            } catch (e) {
              console.log('无法重置播放速度')
            }
          }
        })
      }, 50) // 每50ms检查一次，非常频繁
      
      // 存储全局监控定时器
      this._globalSpeedMonitor = globalSpeedMonitor
      
      // 重写全局的HTMLMediaElement原型
      this.overrideGlobalHTMLMediaElementPrototype()
      
      // 添加更激进的检测方法
      this.addAggressiveDetection()
    },
    
    // 添加更激进的检测方法
    addAggressiveDetection() {
      // 重写所有可能被插件使用的方法
      const originalPlay = HTMLMediaElement.prototype.play
      HTMLMediaElement.prototype.play = function() {
        const result = originalPlay.call(this)
        // 检查播放速度
        setTimeout(() => {
          if (this.playbackRate !== 1.0) {
            console.warn('play方法检测到倍速，暂停视频')
            this.pause()
          }
        }, 100)
        return result
      }
      
      // 监听所有可能的事件
      const events = ['play', 'pause', 'ratechange', 'timeupdate', 'seeked', 'seeking']
      events.forEach(eventType => {
        document.addEventListener(eventType, (e) => {
          if (e.target && e.target.tagName === 'VIDEO') {
            setTimeout(() => {
              if (e.target.playbackRate !== 1.0) {
                console.warn(`事件${eventType}检测到倍速: ${e.target.playbackRate}`)
                e.target.pause()
              }
            }, 10)
          }
        }, true)
      })
      
      // 使用MutationObserver监控DOM变化
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes') {
            const target = mutation.target
            if (target.tagName === 'VIDEO' && mutation.attributeName === 'playbackrate') {
              console.warn('检测到playbackrate属性变化')
              target.pause()
            }
          }
        })
      })
      
      observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['playbackrate', 'data-playback-rate']
      })
    },
    
    // 重写全局HTMLMediaElement原型
    overrideGlobalHTMLMediaElementPrototype() {
      // 检查是否已重写，避免重复执行造成异常
      if (HTMLMediaElement.prototype._isPlaybackRateDefined) return
      Object.defineProperty(HTMLMediaElement.prototype, 'playbackRate', {
        get: function() {
          return this._internalPlaybackRate || 1.0
        },
        set: function(value) {
          console.log(`全局playbackRate setter被调用，值: ${value}`)
          if (value !== 1.0) {
            console.warn(`全局检测到倍速修改: ${value}，暂停视频`)
            this.pause()
            if (window.Vue && this.$message) {
              this.$message.error(`检测到${value}倍速播放，视频已暂停！请使用正常速度观看`)
            }
            this._internalPlaybackRate = 1.0
          } else {
            this._internalPlaybackRate = value
          }
        },
        configurable: true, // 允许后续还能redefine，避免报错
        enumerable: true
      })
      // 打标记，避免重复重写
      HTMLMediaElement.prototype._isPlaybackRateDefined = true
      console.log('全局HTMLMediaElement原型已重写')
    },

    // 获取视频列表
    async getVideoList(courseType) {
      if (!courseType) {
        console.error('课程类型不能为空');
        return;
      }
      
      this.loadingVideos = true;
      
      try {
        // 先加载课程分类
        await this.loadCourseCategories();
        
        // 根据课程类型找到对应的分类ID
        let categoryId = null;
        if (courseType.startsWith('2-')) {
          const index = parseInt(courseType.split('-')[1]) - 1;
          if (this.courseCategories[index]) {
            categoryId = this.courseCategories[index].id;
          }
        } else {
          // 如果是课程名称，查找对应的分类
          const category = this.courseCategories.find(cat => cat.name === courseType);
          if (category) {
            categoryId = category.id;
          }
        }
        
        if (!categoryId) {
          console.error('未找到对应的课程分类:', courseType);
          this.$message.error(`未找到课程类型 "${courseType}" 对应的分类`);
          return;
        }
        
        console.log(`正在获取课程类型 "${courseType}" 的视频列表，分类ID: ${categoryId}`);
        
        const response = await get(`/api.php/v1.video/lists?cid=${categoryId}`);
        if (response.data && response.data.code === 0) {
          const payload = response.data.data || {};
          const videoArr = Array.isArray(payload.video) ? payload.video : [];
          const examMap = payload.exam || {};
          
          // 直接存储到本地数据，使用API返回的unlock字段
          this.courseVideos = videoArr.map(video => ({
            id: video.id,
            title: video.title,
            img: video.image,
            videoUrl: video.url,
            intro: video.intro,
            unlocked: video.unlock === 1,  // 修正：使用unlock字段
            sort: video.sort
          }));
          
          // 解析测试权限：在 exam 中按 cid 查找，unlock=1 为解锁
          let isExamUnlocked = false;
          Object.keys(examMap).forEach(key => {
            const item = examMap[key];
            if (item && item.cid === categoryId) {
              isExamUnlocked = item.unlock === 1;  // 修正：使用unlock字段
            }
          });
          this.examUnlocked = isExamUnlocked;
          
          // 设置课程名称
          this.courseName = courseType;
          
          console.log(`课程类型 "${courseType}" 的视频列表加载成功:`, this.courseVideos);
          console.log('Exam unlocked:', this.examUnlocked);
        } else {
          console.error('获取视频列表失败:', response.data?.msg || '未知错误');
        }
      } catch (error) {
        console.error('获取视频列表失败:', error);
        // this.$message.error(`获取视频列表失败: ${error.message}`);
      } finally {
        this.loadingVideos = false;
      }
    },

    clearAllIntervals() {
      console.log('开始清理所有定时器')
      // 清理所有可能的定时器引用
      const allTimers = [
        '_globalVideoMonitor',
        '_globalSpeedMonitor', 
        '_immediateProtectionInterval',
        '_rateCheckInterval',
        '_forceResetInterval',
        '_globalSpeedCheckInterval',
        '_speedCheckInterval',
        '_ultraFrequentInterval'
      ]
      allTimers.forEach(timerName => {
        if (this[timerName]) {
          console.log(`清理定时器: ${timerName}`)
          clearInterval(this[timerName])
          this[timerName] = null
        }
      })
      // 清理所有视频元素的定时器
      const videos = document.querySelectorAll('video')
      videos.forEach(video => {
        const videoTimers = [
          '_immediateProtectionInterval',
          '_rateCheckInterval', 
          '_forceResetInterval',
          '_globalSpeedCheckInterval',
          '_speedCheckInterval',
          '_ultraFrequentInterval',
          '_timeUpdateHandler'
        ]
        videoTimers.forEach(timerName => {
          if (video[timerName]) {
            console.log(`清理视频定时器: ${timerName}`)
            if (timerName === '_timeUpdateHandler') {
              video.removeEventListener('timeupdate', video[timerName])
            } else {
              clearInterval(video[timerName])
            }
            video[timerName] = null
          }
        })
      })
      // 强制清理所有可能的定时器ID（激进方法）
      for (let i = 1; i < 1000; i++) {
        clearInterval(i)
      }
      console.log('所有定时器清理完成')
    },

    // ========== 防录屏相关方法 ==========
    
    // 初始化防录屏功能
    initScreenBlocking() {
      console.log('初始化防录屏功能')
      
      // 1. 限制键盘快捷键
      this.blockScreenCaptureShortcuts()
      
      // 2. 检测屏幕录制API
      this.detectScreenRecording()
      
      // 3. 禁用开发者工具
      this.disableDevTools()
      
      // 4. 阻止右键菜单
      this.blockContextMenu()
      
      // 5. 检测窗口焦点变化（可能是在录屏）
      this.detectWindowFocus()
      
      // 6. 检测页面可见性变化
      this.detectVisibilityChange()
      
      // 7. 监听全屏状态变化
      this.detectFullscreenChange()
    },
    
    // 检测窗口焦点变化
    detectWindowFocus() {
      let blurCount = 0
      let lastBlurTime = 0
      
      window.addEventListener('blur', () => {
        const now = Date.now()
        // 如果频繁失去焦点，可能是录屏工具在操作
        if (now - lastBlurTime < 1000) {
          blurCount++
          if (blurCount > 3) {
            console.warn('检测到异常窗口焦点变化，可能正在录屏')
            this.handleScreenCaptureDetected('检测到异常操作，请关闭录屏工具')
            // 可以暂停视频
            const video = this.$refs.videoPlayer || this.$refs.videoPlayerOriginal
            if (video && !video.paused) {
              video.pause()
              setTimeout(() => {
                this.showCustomTipMessage('视频已暂停，请关闭录屏工具后继续观看')
              }, 100)
            }
          }
        } else {
          blurCount = 1
        }
        lastBlurTime = now
      })
      
      window.addEventListener('focus', () => {
        blurCount = 0
      })
    },
    
    // 检测页面可见性变化
    detectVisibilityChange() {
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          // 页面不可见时，可能是在切换窗口或录屏
          console.warn('页面变为不可见状态')
          // 可以暂停视频
          const video = this.$refs.videoPlayer || this.$refs.videoPlayerOriginal
          if (video && !video.paused) {
            video.pause()
            // 退出全屏
            this.exitFullscreen()
            // 延迟显示提示，确保全屏已退出
            setTimeout(() => {
              this.showCustomTipMessage('检测到页面切换，视频已暂停')
            }, 100)
          }
        }
      })
    },
    
    // 检测全屏状态变化
    detectFullscreenChange() {
      // 监听全屏状态变化事件
      const fullscreenChangeEvents = [
        'fullscreenchange',
        'webkitfullscreenchange',
        'mozfullscreenchange',
        'MSFullscreenChange'
      ]
      
      fullscreenChangeEvents.forEach(eventName => {
        document.addEventListener(eventName, () => {
          // 当全屏状态改变时，确保提示框的z-index正确
          if (this.showCustomTip) {
            this.$nextTick(() => {
              const tipOverlay = document.querySelector('.custom-tip-overlay')
              if (tipOverlay) {
                tipOverlay.style.zIndex = '2147483647'
              }
            })
          }
        })
      })
    },

    // 限制屏幕录制相关的键盘快捷键
    blockScreenCaptureShortcuts() {
      // 创建键盘事件拦截器
      const keydownHandler = (event) => {
        const key = event.key
        const code = event.code
        const keyCode = event.keyCode || event.which
        
        // PrintScreen键的多种检测方式
        // keyCode 44 是PrintScreen
        if (code === 'PrintScreen' || 
            key === 'PrintScreen' || 
            keyCode === 44 ||
            (event.shiftKey && keyCode === 44) ||
            (event.ctrlKey && keyCode === 44)) {
          event.preventDefault()
          event.stopPropagation()
          event.stopImmediatePropagation()
          // 处理全屏状态和显示警告
          this.handleScreenCaptureDetected('禁止截图！')
          return false
        }
        
        // 阻止Win+Shift+S (Windows截图工具) - 更精确的检测
        if ((event.key === 's' || event.key === 'S') && 
            event.shiftKey && 
            (event.metaKey || (event.ctrlKey && navigator.platform.indexOf('Win') !== -1))) {
          event.preventDefault()
          event.stopPropagation()
          event.stopImmediatePropagation()
          this.handleScreenCaptureDetected('禁止截图！')
          return false
        }
        
        // 阻止Win+Shift+R (Windows录屏工具)
        if ((event.key === 'r' || event.key === 'R') && 
            event.shiftKey && 
            (event.metaKey || (event.ctrlKey && navigator.platform.indexOf('Win') !== -1))) {
          event.preventDefault()
          event.stopPropagation()
          event.stopImmediatePropagation()
          this.handleScreenCaptureDetected('禁止录屏！')
          return false
        }
        
        // 阻止Alt+PrintScreen
        if ((code === 'PrintScreen' || keyCode === 44) && event.altKey) {
          event.preventDefault()
          event.stopPropagation()
          event.stopImmediatePropagation()
          this.handleScreenCaptureDetected('禁止截图！')
          return false
        }
        
        // 阻止Ctrl+Shift+I (开发者工具)
        if (event.key === 'I' && event.ctrlKey && event.shiftKey) {
          event.preventDefault()
          event.stopPropagation()
          event.stopImmediatePropagation()
          return false
        }
        
        // 阻止Ctrl+Shift+C (检查元素)
        if (event.key === 'C' && event.ctrlKey && event.shiftKey) {
          event.preventDefault()
          event.stopPropagation()
          event.stopImmediatePropagation()
          return false
        }
        
        // 阻止Ctrl+U (查看源代码)
        if (event.key === 'u' && event.ctrlKey) {
          event.preventDefault()
          event.stopPropagation()
          event.stopImmediatePropagation()
          return false
        }
        
        // 阻止Ctrl+S (保存页面)
        if (event.key === 's' && event.ctrlKey && !event.shiftKey) {
          event.preventDefault()
          event.stopPropagation()
          event.stopImmediatePropagation()
          return false
        }
      }
      
      // 使用捕获模式，并且在多个阶段拦截
      document.addEventListener('keydown', keydownHandler, true)
      document.addEventListener('keypress', keydownHandler, true)
      document.addEventListener('keyup', keydownHandler, true)
      
      // 保存处理器以便后续清理
      this._keydownHandler = keydownHandler
      
      // 额外的保护：监听beforeprint事件（打印时也会触发截图）
      window.addEventListener('beforeprint', (e) => {
        e.preventDefault()
        this.handleScreenCaptureDetected('禁止打印/截图！')
      })
    },
    
    // 处理检测到屏幕录制/截图
    handleScreenCaptureDetected(message) {
      // 1. 退出全屏状态
      this.exitFullscreen()
      
      // 2. 暂停视频
      const video = this.$refs.videoPlayer || this.$refs.videoPlayerOriginal
      if (video && !video.paused) {
        video.pause()
      }
      
      // 3. 触发页面闪烁来干扰截图
      this.flashScreen()
      
      // 4. 显示警告提示（延迟一下，确保全屏已退出）
      setTimeout(() => {
        this.showCustomTipMessage(message)
      }, 100)
    },
    
    // 退出全屏
    exitFullscreen() {
      try {
        if (document.fullscreenElement) {
          document.exitFullscreen()
        } else if (document.webkitFullscreenElement) {
          document.webkitExitFullscreen()
        } else if (document.mozFullScreenElement) {
          document.mozCancelFullScreen()
        } else if (document.msFullscreenElement) {
          document.msExitFullscreen()
        }
        
        // 也检查video元素是否在全屏
        const video = this.$refs.videoPlayer || this.$refs.videoPlayerOriginal
        if (video) {
          if (video.webkitDisplayingFullscreen) {
            video.webkitExitFullscreen()
          }
          if (video.requestFullscreen && document.fullscreenElement === video) {
            document.exitFullscreen()
          }
        }
      } catch (e) {
        console.warn('退出全屏失败:', e)
      }
    },
    
    // 显示自定义小框提示
    showCustomTipMessage(text) {
      this.customTipText = text
      this.showCustomTip = true
      
      // 清除之前的定时器（不再自动隐藏，需要用户点击确认）
      if (this.customTipTimer) {
        clearTimeout(this.customTipTimer)
        this.customTipTimer = null
      }
      
      // 确保提示框在最上层（即使在全屏元素上也能显示）
      this.$nextTick(() => {
        const tipOverlay = document.querySelector('.custom-tip-overlay')
        if (tipOverlay) {
          tipOverlay.style.zIndex = '2147483647' // 使用最大z-index值
        }
      })
    },
    
    // 处理确认按钮点击
    handleConfirmTip() {
      this.showCustomTip = false
    },
    
    // 屏幕闪烁干扰截图
    flashScreen() {
      const flashDiv = document.createElement('div')
      flashDiv.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: white;
        z-index: 999999;
        opacity: 0.9;
        pointer-events: none;
      `
      document.body.appendChild(flashDiv)
      
      setTimeout(() => {
        flashDiv.style.opacity = '0'
        flashDiv.style.transition = 'opacity 0.3s'
        setTimeout(() => {
          document.body.removeChild(flashDiv)
        }, 300)
      }, 100)
    },

    // 登录失效提示
    promptLoginExpired(message = '登录令牌失效，请重新登录') {
      this.$confirm(message, '提示', {
        confirmButtonText: '去登录',
        showCancelButton: false,
        type: 'warning',
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(() => {
        window.location.href = 'https://www.camh.org.cn/user/login.html'
      }).catch(() => {})
    },

    // 检测屏幕录制
    detectScreenRecording() {
      // 检测getDisplayMedia API（屏幕共享）
      if (navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia) {
        navigator.mediaDevices.getDisplayMedia = function() {
          console.warn('检测到屏幕录制尝试')
          return Promise.reject(new DOMException('屏幕录制已被禁用', 'NotAllowedError'))
        }
      }
      
      // 检测getUserMedia（可能用于录屏）
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        const originalGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices)
        
        navigator.mediaDevices.getUserMedia = function(constraints) {
          // 如果请求屏幕或窗口，则拒绝
          if (constraints && constraints.video) {
            const video = constraints.video
            if (video === 'screen' || video === 'window' || 
                (typeof video === 'object' && (video.mediaSource === 'screen' || video.mediaSource === 'window'))) {
              console.warn('检测到屏幕录制尝试')
              return Promise.reject(new DOMException('屏幕录制已被禁用', 'NotAllowedError'))
            }
          }
          return originalGetUserMedia(constraints)
        }
      }
    },

    // 禁用开发者工具
    disableDevTools() {
      // 检测开发者工具是否打开（简化版本，避免影响正常使用）
      const checkDevTools = () => {
        const threshold = 160
        if (window.outerHeight - window.innerHeight > threshold || 
            window.outerWidth - window.innerWidth > threshold) {
          // 可能打开了开发者工具，但不做强制处理，避免误判
          console.warn('检测到可能打开了开发者工具')
        }
      }
      
      // 定期检查（降低频率，避免性能问题）
      setInterval(checkDevTools, 2000)
    },

    // 阻止右键菜单
    blockContextMenu() {
      document.addEventListener('contextmenu', (e) => {
        e.preventDefault()
        e.stopPropagation()
        return false
      }, true)
      
      // 也阻止视频元素的右键菜单
      document.addEventListener('contextmenu', (e) => {
        if (e.target.tagName === 'VIDEO' || e.target.closest('video')) {
          e.preventDefault()
          e.stopPropagation()
          this.$message.warning('右键菜单已被禁用')
          return false
        }
      }, true)
    },

    // 清理防录屏资源
    cleanupScreenBlocking() {
      console.log('清理防录屏资源')
      
      // 清理键盘事件监听器
      if (this._keydownHandler) {
        document.removeEventListener('keydown', this._keydownHandler, true)
        document.removeEventListener('keypress', this._keydownHandler, true)
        document.removeEventListener('keyup', this._keydownHandler, true)
        this._keydownHandler = null
      }
      
      // 清理屏幕录制检测定时器
      if (this.screenBlockInterval) {
        clearInterval(this.screenBlockInterval)
        this.screenBlockInterval = null
      }
      
      // 清理自定义提示定时器
      if (this.customTipTimer) {
        clearTimeout(this.customTipTimer)
        this.customTipTimer = null
      }
    }
  },

  mounted() {
    // 添加全局键盘事件监听器，禁用方向键（使用捕获模式）
    document.addEventListener('keydown', this.handleGlobalKeydown, true)
    
    // 启动全局防护机制
    this.startGlobalProtection()
    
    // 启动强力倍速检测
    this.startAggressiveSpeedDetection()
    
    // 添加路由离开监听
    this.$router.beforeEach((to, from, next) => {
      if (from.name === 'Learning') {
        console.log('路由离开Learning页面，清理所有定时器')
        this.clearAllIntervals()
      }
      next()
    })
    
    // 处理从路由传递过来的参数
    const { courseType, videoId } = this.$route.query
      console.log('mounted - route query:', { courseType, videoId })
    
    // 初始化防录屏功能
    this.initScreenBlocking()
    
    if (courseType) {
      // 确保先设置课程类型，这样isFromNotice就能正确返回true
      this.$store.commit('setCurrentCourseType', courseType)
      console.log('mounted - setCurrentCourseType:', courseType)
      
      // 调用接口获取视频列表
      this.getVideoList(courseType).then(() => {
        console.log('mounted - getVideoList completed')
        if (videoId) {
          this.$store.commit('setCurrentVideoId', videoId)
          // 查找目标视频的索引
          const targetVideoIndex = this.courseVideos.findIndex(video => video.id === parseInt(videoId));
          if (targetVideoIndex !== -1) {
          // 检查目标视频是否已解锁
            if (this.courseVideos[targetVideoIndex].unlocked) {
            this.currentVideoIndex = targetVideoIndex
            // 获取目标视频的详情
            this.selectVideo(targetVideoIndex)
          } else {
              // 如果目标视频未解锁，跳转到第一个已解锁的视频
              const firstUnlockedIndex = this.courseVideos.findIndex(video => video.unlocked);
              if (firstUnlockedIndex !== -1) {
                this.currentVideoIndex = firstUnlockedIndex
                this.$message.warning('该视频尚未解锁，已跳转到第一个可观看的视频')
                this.selectVideo(firstUnlockedIndex)
              } else {
            this.currentVideoIndex = 0
                this.$message.warning('没有可观看的视频')
                this.selectVideo(0)
              }
            }
          } else {
            // 如果找不到目标视频，跳转到第一个视频
            this.currentVideoIndex = 0
            this.selectVideo(0)
          }
        } else {
          // 如果没有指定视频ID，默认选择第一个视频
          this.selectVideo(0)
        }
      }).catch(error => {
        console.error('加载视频列表失败:', error);
        this.$message.error('加载视频列表失败，请稍后重试');
      });
    } else {
      console.log('mounted - no courseType in route query')
    }
  },

  beforeDestroy() {
    console.log('开始清理所有定时器和监听器')
    
    // 设置组件销毁标志
    this.isDestroyed = true
    
    // 清理防录屏相关资源
    this.cleanupScreenBlocking()
    
    // 移除全局键盘事件监听器
    document.removeEventListener('keydown', this.handleGlobalKeydown)
    
    // 清理全局监控定时器
    if (this._globalVideoMonitor) {
      clearInterval(this._globalVideoMonitor)
      this._globalVideoMonitor = null
    }
    if (this._globalSpeedMonitor) {
      clearInterval(this._globalSpeedMonitor)
      this._globalSpeedMonitor = null
    }
    
    // 清理视频元素的定时器
    const videos = document.querySelectorAll('video')
    videos.forEach(video => {
      if (video._immediateProtectionInterval) {
        clearInterval(video._immediateProtectionInterval)
        video._immediateProtectionInterval = null
      }
      if (video._rateCheckInterval) {
        clearInterval(video._rateCheckInterval)
        video._rateCheckInterval = null
      }
      if (video._forceResetInterval) {
        clearInterval(video._forceResetInterval)
        video._forceResetInterval = null
      }
      if (video._globalSpeedCheckInterval) {
        clearInterval(video._globalSpeedCheckInterval)
        video._globalSpeedCheckInterval = null
      }
      if (video._speedCheckInterval) {
        clearInterval(video._speedCheckInterval)
        video._speedCheckInterval = null
      }
      if (video._timeUpdateHandler) {
        video.removeEventListener('timeupdate', video._timeUpdateHandler)
        video._timeUpdateHandler = null
      }
      if (video._ultraFrequentInterval) {
        clearInterval(video._ultraFrequentInterval)
        video._ultraFrequentInterval = null
      }
    })
    
    // 清理所有可能的定时器
    this.clearAllIntervals()
    
    console.log('所有定时器和监听器已清理完成')
  },
  
  watch: {
    currentLesson: {
      handler() {
        // 重置用户答案
        this.userAnswers = {}
      },
      immediate: true
    },
    currentContent: {
      handler() {
        // 当视频内容改变时，重新锁定播放速度
        this.$nextTick(() => {
          this.disablePictureInPicture()
          this.lockVideoPlaybackRate()
        })
      },
      immediate: true
    },
    // 监听路由参数变化
    '$route.query': {
      handler(newQuery) {
        const { courseType, videoId } = newQuery
        if (courseType && courseType !== this.currentCourseType) {
          // 课程类型发生变化，重新加载数据
          this.$store.commit('setCurrentCourseType', courseType)
          this.getVideoList(courseType).then(() => {
            if (videoId) {
              this.$store.commit('setCurrentVideoId', videoId)
              // 修正: 用 findIndex 定位id而不是下标
              const targetVideoIndex = this.courseVideos.findIndex(video => video.id === parseInt(videoId));
              if (targetVideoIndex !== -1) {
                if (this.courseVideos[targetVideoIndex].unlocked) {
                  this.currentVideoIndex = targetVideoIndex
                  this.selectVideo(targetVideoIndex)
                } else {
                  const firstUnlockedIndex = this.courseVideos.findIndex(video => video.unlocked);
                  if (firstUnlockedIndex !== -1) {
                    this.currentVideoIndex = firstUnlockedIndex
                    this.$message.warning('该视频尚未解锁，已跳转到第一个可观看的视频')
                    this.selectVideo(firstUnlockedIndex)
                  } else {
                    this.currentVideoIndex = 0
                    this.$message.warning('没有可观看的视频')
                    this.selectVideo(0)
                  }
                }
              } else {
                this.currentVideoIndex = 0
                this.selectVideo(0)
              }
            } else {
              this.selectVideo(0)
            }
          }).catch(error => {
            console.error('加载视频列表失败:', error);
            this.$message.error('加载视频列表失败，请稍后重试');
          });
        }
      },
      immediate: true
    },

  }
}
</script>

<style scoped>
.learning-container {
  min-height: 100vh;
  background: #f5f5f5;
}

.learning-header {
  background: white;
  padding: 20px 30px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
}

.back-btn {
  margin-right: 20px;
  color: #2a91ff;
}

.header-left h2 {
  margin: 0;
  color: #333;
}

.progress-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.progress-info span {
  color: #666;
  font-size: 14px;
}

.learning-content {
  display: flex;
  height: calc(100vh - 100px);
}

.chapter-sidebar {
  width: 350px;
  background: white;
  border-right: 1px solid #e9ecef;
  overflow-y: auto;
}

.sidebar-header {
  padding: 20px;
  border-bottom: 1px solid #e9ecef;
}

.sidebar-header h3 {
  margin: 0;
  color: #333;
}

.chapter-list {
  padding: 10px;
}

.chapter-item {
  margin-bottom: 10px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
}

.chapter-item:hover {
  background: #f8f9fa;
}

.chapter-item.active {
  background: #e3f2fd;
}

.chapter-header {
  padding: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #f8f9fa;
}

.chapter-title {
  flex: 1;
  font-weight: 500;
  color: #333;
}

.chapter-progress {
  color: #666;
  font-size: 12px;
}

.lesson-list {
  background: white;
}

.lesson-item {
  padding: 12px 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: all 0.3s ease;
}

.lesson-item:hover {
  background: #f8f9fa;
}

.lesson-item.active {
  background: #e3f2fd;
  border-left: 3px solid #2a91ff;
}

.lesson-item.completed {
  background: #f0f9ff;
}

.lesson-icon {
  color: #2a91ff;
  font-size: 16px;
}

.lesson-info {
  flex: 1;
}

.lesson-title {
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
}

.lesson-meta {
  font-size: 12px;
  color: #666;
}

.lesson-status {
  color: #52c41a;
}

/* 课程内容样式 */
.course-content {
  padding: 0 20px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin: 20px 0 15px 0;
  padding-bottom: 8px;
  border-bottom: 2px solid #2a91ff;
}

.video-section, .test-section {
  margin-bottom: 30px;
}

.video-list, .test-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.video-item, .test-item {
  display: flex;
  align-items: center;
  padding: 12px 15px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.video-item:hover, .test-item:hover {
  background: rgba(102, 126, 234, 0.1);
  transform: translateX(5px);
}

.video-item.active, .test-item.active {
  background: rgba(102, 126, 234, 0.2);
  border-color: #2a91ff;
  transform: translateX(5px);
}

/* 锁定状态样式 */
.video-item.locked {
  background: rgba(200, 200, 200, 0.3);
  cursor: not-allowed;
  opacity: 0.6;
}

.video-item.locked:hover {
  background: rgba(200, 200, 200, 0.3);
  transform: none;
}

.video-item.locked .video-title,
.video-item.locked .video-meta {
  color: #999;
}

/* 已完成状态样式 */
.video-item.completed {
  background: rgba(82, 196, 26, 0.1);
  border-color: rgba(82, 196, 26, 0.3);
}

.video-item.completed .video-icon {
  background: #52c41a;
}

.video-icon, .test-icon {
  width: 40px;
  height: 40px;
  background: #2a91ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  margin-right: 12px;
  font-size: 18px;
}

.video-info, .test-info {
  flex: 1;
}

.video-title, .test-title {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
}

.video-meta, .test-meta {
  font-size: 12px;
  color: #666;
}

.video-status {
  margin-left: auto;
}

.video-actions {
  margin-top: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.learning-main {
  flex: 1;
  padding: 30px;
  overflow-y: auto;
}

.lesson-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e9ecef;
}

.lesson-header h2 {
  margin: 0;
  color: #333;
}

.lesson-nav {
  display: flex;
  gap: 10px;
}

.lesson-content {
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.video-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  position: relative;
}

.video-player {
  width: 100%;
  max-width: 800px;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}


/* 隐藏敏感内容的CSS类 */
.hidden {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
}

/* 自定义小框提示样式 */
.custom-tip-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2147483647; /* 使用最大z-index值，确保在全屏元素上也能显示 */
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 全屏状态下也确保提示框可见 */
:fullscreen .custom-tip-overlay,
:-webkit-full-screen .custom-tip-overlay,
:-moz-full-screen .custom-tip-overlay,
:-ms-fullscreen .custom-tip-overlay {
  z-index: 2147483647;
  position: fixed;
}

.custom-tip-box {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  min-width: 320px;
  max-width: 500px;
  overflow: hidden;
}

.custom-tip-content {
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 16px;
  color: #333;
}

.custom-tip-content i {
  font-size: 20px;
  color: #f56c6c;
  flex-shrink: 0;
}

.custom-tip-content span {
  flex: 1;
  line-height: 1.5;
}

.custom-tip-footer {
  padding: 12px 24px;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: flex-end;
  background: #f8f9fa;
}

.custom-tip-confirm-btn {
  padding: 8px 24px;
  background: #409eff;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.custom-tip-confirm-btn:hover {
  background: #66b1ff;
}

.custom-tip-confirm-btn:active {
  background: #3a8ee6;
}

/* 提示框淡入淡出动画 */
.tip-fade-enter-active,
.tip-fade-leave-active {
  transition: opacity 0.3s ease;
}

.tip-fade-enter-active .custom-tip-box,
.tip-fade-leave-active .custom-tip-box {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.tip-fade-enter .custom-tip-box,
.tip-fade-leave-to .custom-tip-box {
  transform: scale(0.9);
  opacity: 0;
}

.tip-fade-enter,
.tip-fade-leave-to {
  opacity: 0;
}

/* 防止选择文本 */
.video-container,
.video-player {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}


/* 隐藏视频播放器的更多选项菜单 */
.video-player::-webkit-media-controls-more-button {
  display: none !important;
}

.video-player::-webkit-media-controls-overlay-play-button {
  display: none !important;
}

/* 隐藏倍速控制 - 多种选择器 */
.video-player::-webkit-media-controls-playback-rate-button {
  display: none !important;
}

.video-player::-webkit-media-controls-playback-rate-button {
  display: none !important;
}

.video-player::-webkit-media-controls-current-time-display {
  display: none !important;
}

/* 隐藏所有可能包含倍速的控件 */
.video-player::-webkit-media-controls-time-remaining-display {
  display: none !important;
}

.video-player::-webkit-media-controls-timeline {
  display: block !important;
}

/* 隐藏右键菜单中的倍速选项 */
.video-player::-webkit-media-controls-enclosure {
  overflow: hidden;
}

/* 隐藏画中画按钮 - 多种选择器 */
.video-player::-webkit-media-controls-picture-in-picture-button {
  display: none !important;
}

.video-player::-webkit-media-controls-picture-in-picture-button {
  display: none !important;
}

/* 隐藏全屏按钮 */
.video-player::-webkit-media-controls-fullscreen-button {
  display: none !important;
}



/* 通用隐藏所有不需要的控件 */
.video-player::-webkit-media-controls-timeline {
  display: block !important;
}

.video-player::-webkit-media-controls-play-button {
  display: block !important;
}

.video-player::-webkit-media-controls-volume-slider {
  display: block !important;
}

.video-player::-webkit-media-controls-mute-button {
  display: block !important;
}

/* 强制隐藏倍速相关控件 */
.video-player::-webkit-media-controls-playback-rate-menu-button {
  display: none !important;
}

.video-player::-webkit-media-controls-playback-rate-menu-list {
  display: none !important;
}

/* 隐藏所有可能的倍速显示 */
.video-player::-webkit-media-controls-playback-rate-display {
  display: none !important;
}

/* 确保时间显示不包含倍速信息 */
.video-player::-webkit-media-controls-current-time-display {
  display: block !important;
  font-size: 12px !important;
}

/* 隐藏所有可能的倍速显示和控件 */
.video-player::-webkit-media-controls-playback-rate-menu-button,
.video-player::-webkit-media-controls-playback-rate-menu-list,
.video-player::-webkit-media-controls-playback-rate-display,
.video-player::-webkit-media-controls-playback-rate-button {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
  pointer-events: none !important;
}

/* 禁用进度条拖拽功能 */
.video-player::-webkit-media-controls-timeline {
  pointer-events: none !important;
  user-select: none !important;
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
}

/* 禁用进度条的所有交互 */
.video-player::-webkit-media-controls-timeline:hover {
  pointer-events: none !important;
}

.video-player::-webkit-media-controls-timeline:active {
  pointer-events: none !important;
}

/* 禁用进度条的拖拽手柄 */
.video-player::-webkit-media-controls-timeline::-webkit-slider-thumb {
  pointer-events: none !important;
  user-select: none !important;
  -webkit-user-select: none !important;
}

/* 禁用整个进度条区域 */
.video-player::-webkit-media-controls-timeline::-webkit-slider-track {
  pointer-events: none !important;
  user-select: none !important;
  -webkit-user-select: none !important;
}

/* 强制隐藏倍速相关的所有元素 */
.video-player *[class*="playback-rate"],
.video-player *[class*="rate"] {
  display: none !important;
}

/* 隐藏所有可能的倍速控件 - 更全面的选择器 */
.video-player::-webkit-media-controls-playback-rate-menu-button,
.video-player::-webkit-media-controls-playback-rate-menu-list,
.video-player::-webkit-media-controls-playback-rate-display,
.video-player::-webkit-media-controls-playback-rate-button,
.video-player::-webkit-media-controls-playback-rate-menu,
.video-player::-webkit-media-controls-playback-rate-menu-item {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
  pointer-events: none !important;
  width: 0 !important;
  height: 0 !important;
  overflow: hidden !important;
}

/* 隐藏右键菜单中的倍速选项 */
.video-player::-webkit-media-controls-enclosure {
  overflow: hidden;
}

/* 强制隐藏所有包含速度相关文本的元素 */
.video-player *:contains("0.5x"),
.video-player *:contains("1x"),
.video-player *:contains("1.5x"),
.video-player *:contains("2x"),
.video-player *:contains("倍速"),
.video-player *:contains("速度") {
  display: none !important;
}

.video-placeholder {
  background: #f8f9fa;
  border: 2px dashed #dee2e6;
  border-radius: 8px;
  padding: 60px;
  text-align: center;
  color: #666;
}

.video-placeholder i {
  font-size: 48px;
  color: #2a91ff;
  margin-bottom: 15px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.video-note {
  font-size: 12px;
  color: #999;
  margin-top: 10px;
  font-style: italic;
}

.video-url {
  font-size: 12px;
  color: #999;
  margin-top: 10px;
}

.video-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.video-duration {
  color: #666;
  display: flex;
  align-items: center;
  gap: 5px;
}

.question-item {
  margin-bottom: 30px;
  padding: 20px;
  border: 1px solid #e9ecef;
  border-radius: 8px;
}

.question-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.question-number {
  font-weight: 500;
  color: #333;
}

.question-type {
  color: #2a91ff;
  font-size: 12px;
  background: #e3f2fd;
  padding: 2px 8px;
  border-radius: 4px;
}

.question-content h4 {
  margin: 0 0 15px 0;
  color: #333;
  line-height: 1.6;
}

.options {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.option-item {
  margin: 0 !important;
  padding: 10px;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.option-item:hover {
  background: #f8f9fa;
}

.quiz-actions {
  margin-top: 30px;
  display: flex;
  gap: 15px;
  justify-content: center;
}

.empty-state {
  text-align: center;
  padding: 80px 20px;
  color: #666;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.empty-state i {
  font-size: 48px;
  color: #ccc;
  margin-bottom: 20px;
  display: block;
}

.empty-state p {
  font-size: 16px;
  margin: 0;
  color: #999;
}

@media (max-width: 768px) {
  .learning-content {
    flex-direction: column;
  }
  
  .chapter-sidebar {
    width: 100%;
    height: 300px;
  }
  
  .learning-main {
    padding: 20px;
  }
  
  .lesson-header {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }
}
</style> 